import { useBase as T, SvComponent as c, key2ClickDirective as N, SurveyComponent as Q, useQuestion as H, ComponentFactory as re } from "survey-vue3-ui";
import { defineComponent as g, computed as w, toRaw as _e, ref as I, onMounted as B, onUnmounted as K, openBlock as l, createElementBlock as r, Fragment as $, createVNode as p, unref as s, createElementVNode as a, normalizeClass as _, normalizeStyle as F, withDirectives as h, vShow as L, createCommentVNode as m, renderList as R, createBlock as C, toDisplayString as k, renderSlot as Z, withCtx as Y, resolveDirective as x, createTextVNode as ge, shallowRef as be, watch as G, onBeforeUnmount as ee, vModelText as de, onUpdated as oe, mergeProps as V } from "vue";
import { ResponsivityManager as ye, CssClassBuilder as he, RendererFactory as ue, DropdownListModel as qe, VerticalResponsivityManager as Ce } from "survey-core";
import { ScrollViewModel as we, editorLocalization as ce, SurveyResultsModel as ke, initLogicOperator as fe, StringEditorViewModelBase as $e, ToolboxToolViewModel as Te, PageAdorner as De, RowViewModel as Ne, QuestionAdornerViewModel as se, QuestionImageAdornerViewModel as Me, QuestionRatingAdornerViewModel as Se, MatrixCellWrapperViewModel as Ee, ItemValueWrapperViewModel as Ie, ImageItemValueWrapperViewModel as Be, LogoImageViewModel as Pe, PageNavigatorViewModel as Re, QuestionDropdownAdornerViewModel as Ve, editableStringRendererName as ze } from "survey-creator-core";
const Ae = { class: "svc-flex-column svc-flex-row__element svc-flex-row__element--growing" }, Le = { class: "svc-top-bar" }, Fe = { class: "svc-tabbed-menu-wrapper" }, Ke = ["v-show"], Ue = { class: "svc-creator__content-holder svc-flex-column" }, He = ["id"], Oe = {
  key: 0,
  class: "svc-footer-bar"
}, Qe = ["v-show"], Ge = {
  key: 0,
  class: "svc-creator__banner"
}, We = ["innerHTML"], je = /* @__PURE__ */ g({
  __name: "Creator",
  props: {
    model: {}
  },
  setup(u) {
    const t = u, e = w(() => _e(t.model)), o = I();
    return T(
      () => e.value,
      (n, i) => {
        i && i.unsubscribeRootElement(), n && o.value && n.setRootElement(o.value);
      }
    ), B(() => {
      o.value && t.model.setRootElement(o.value);
    }), K(() => {
      t.model.unsubscribeRootElement();
    }), (n, i) => e.value.isCreatorDisposed ? m("", !0) : (l(), r($, { key: 0 }, [
      p(s(c), { is: "survey-popup-modal" }),
      a("div", {
        class: _(e.value.getRootCss()),
        style: F(e.value.themeVariables),
        ref_key: "root",
        ref: o
      }, [
        a("div", null, [
          p(s(c), { is: "sv-svg-bundle" })
        ]),
        a("div", {
          class: _(["svc-full-container svc-creator__area svc-flex-column", {
            "svc-creator__area--with-banner": !e.value.haveCommercialLicense
          }])
        }, [
          a("div", {
            class: _(["svc-flex-row svc-full-container", {
              "svc-creator__side-bar--left": e.value.sidebarLocation == "left"
            }])
          }, [
            a("div", Ae, [
              a("div", Le, [
                h(a("div", Fe, [
                  p(s(c), {
                    is: "svc-tabbed-menu",
                    model: e.value.tabbedMenu
                  }, null, 8, ["model"])
                ], 512), [
                  [L, e.value.showTabs]
                ]),
                e.value.showToolbar ? (l(), r("div", {
                  key: 0,
                  class: "svc-toolbar-wrapper",
                  "v-show": e.value.showToolbar
                }, [
                  p(s(c), {
                    is: "sv-action-bar",
                    model: e.value.toolbar
                  }, null, 8, ["model"])
                ], 8, Ke)) : m("", !0)
              ]),
              a("div", {
                class: _(["svc-creator__content-wrapper svc-flex-row", {
                  "svc-creator__content-wrapper--footer-toolbar": e.value.isMobileView
                }])
              }, [
                a("div", Ue, [
                  (l(!0), r($, null, R(e.value.tabs, (d) => (l(), r($, null, [
                    e.value.viewType == d.id && d.visible ? (l(), r("div", {
                      class: _(["svc-creator-tab", {
                        "svc-creator__toolbox--right": e.value.toolboxLocation == "right"
                      }]),
                      key: d.id,
                      id: "scrollableDiv-" + d.id
                    }, [
                      p(s(c), {
                        is: d.componentContent,
                        model: d.data.model
                      }, null, 8, ["is", "model"])
                    ], 10, He)) : m("", !0)
                  ], 64))), 256))
                ])
              ], 2),
              e.value.isMobileView ? (l(), r("div", Oe, [
                a("div", {
                  class: "svc-toolbar-wrapper",
                  "v-show": e.value.isMobileView
                }, [
                  p(s(c), {
                    is: "sv-action-bar",
                    model: e.value.footerToolbar
                  }, null, 8, ["model"])
                ], 8, Qe)
              ])) : m("", !0)
            ]),
            e.value.sidebar ? (l(), C(s(c), {
              key: 0,
              is: "svc-side-bar",
              model: e.value.sidebar
            }, null, 8, ["model"])) : m("", !0)
          ], 2),
          e.value.haveCommercialLicense ? m("", !0) : (l(), r("div", Ge, [
            a("span", {
              class: "svc-creator__non-commercial-text",
              innerHTML: e.value.licenseText
            }, null, 8, We)
          ])),
          p(s(c), {
            is: "sv-notifier",
            model: e.value.notifier
          }, null, 8, ["model"])
        ], 2)
      ], 6)
    ], 64));
  }
}), Je = /* @__PURE__ */ g({
  __name: "TabbedMenu",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    let e;
    const o = I();
    return T(() => t.model), B(() => {
      e = new ye(
        o.value,
        t.model,
        ".svc-tabbed-menu-item-container:not(.sv-dots)>.sv-action__content"
      );
    }), K(() => {
      e.dispose(), e = void 0;
    }), (n, i) => (l(), r("div", {
      class: "svc-tabbed-menu",
      ref_key: "container",
      ref: o
    }, [
      (l(!0), r($, null, R(n.model.renderedActions, (d) => (l(), C(s(c), {
        key: d.id,
        is: "svc-tabbed-menu-item-wrapper",
        item: d
      }, null, 8, ["item"]))), 128))
    ], 512));
  }
}), Ze = { class: "sv-action__content" }, Xe = /* @__PURE__ */ g({
  __name: "TabbedMenuItemWrapper",
  props: {
    item: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.item), (e, o) => (l(), r("span", {
      class: _(["svc-tabbed-menu-item-container", [e.item.isVisible ? "" : "sv-action--hidden", e.item.css]])
    }, [
      a("div", Ze, [
        p(s(c), {
          is: e.item.component || "svc-tabbed-menu-item",
          item: e.item
        }, null, 8, ["is", "item"])
      ])
    ], 2));
  }
}), Ye = /* @__PURE__ */ g({
  __name: "TabbedMenuItem",
  props: {
    item: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.item), (e, o) => h((l(), r("div", {
      class: _(["svc-tabbed-menu-item", e.item.getRootCss()]),
      onClick: o[0] || (o[0] = (...n) => e.item.action && e.item.action(...n))
    }, [
      e.item.hasTitle ? (l(), r("span", {
        key: 0,
        class: _(e.item.getTitleCss())
      }, k(e.item.title), 3)) : m("", !0),
      e.item.hasIcon ? (l(), C(s(c), {
        key: 1,
        is: "sv-svg-icon",
        iconName: e.item.iconName,
        size: "auto",
        class: _(e.item.getIconCss()),
        title: e.item.tooltip || e.item.title
      }, null, 8, ["iconName", "class", "title"])) : m("", !0)
    ], 2)), [
      [s(N)]
    ]);
  }
}), xe = { class: "svc-flex-row svc-side-bar__wrapper" }, eo = { class: "svc-side-bar__container-wrapper" }, oo = { class: "svc-side-bar__container-content" }, so = /* @__PURE__ */ g({
  __name: "SideBar",
  props: {
    model: {}
  },
  setup(u) {
    const t = u, e = I();
    return T(() => t.model), B(() => {
      t.model.initResizeManager(e.value);
    }), K(() => {
      t.model.resetResizeManager();
    }), (o, n) => h((l(), r("div", {
      class: _(["svc-side-bar", o.model.rootCss])
    }, [
      h(a("div", {
        class: "svc-side-bar__shadow",
        onClick: n[0] || (n[0] = () => o.model.collapseSidebar())
      }, null, 512), [
        [L, o.model.renderContainer]
      ]),
      a("div", xe, [
        h(a("div", eo, [
          a("div", {
            class: "svc-side-bar__container",
            ref_key: "root",
            ref: e
          }, [
            p(s(c), {
              is: o.model.header.component,
              model: o.model.header.componentModel
            }, null, 8, ["is", "model"]),
            a("div", oo, [
              (l(!0), r($, null, R(o.model.pages, (i, d) => (l(), C(s(c), {
                key: d,
                is: "svc-side-bar-page",
                model: i
              }, null, 8, ["model"]))), 128))
            ])
          ], 512)
        ], 512), [
          [L, o.model.renderContainer]
        ]),
        o.model.sideAreaComponentName ? (l(), C(s(c), {
          key: 0,
          is: o.model.sideAreaComponentName,
          model: o.model.sideAreaComponentData
        }, null, 8, ["is", "model"])) : m("", !0)
      ])
    ], 2)), [
      [L, o.model.renderRoot]
    ]);
  }
}), to = { class: "svc-side-bar__container-header" }, no = { class: "svc-side-bar__container-actions" }, lo = {
  key: 0,
  class: "svc-side-bar__container-title"
}, io = /* @__PURE__ */ g({
  __name: "SideBarDefaultHeader",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", to, [
      a("div", no, [
        p(s(c), {
          is: "sv-action-bar",
          model: e.model.toolbar
        }, null, 8, ["model"])
      ]),
      e.model.title ? (l(), r("div", lo, k(e.model.title), 1)) : m("", !0)
    ]));
  }
}), ao = /* @__PURE__ */ g({
  __name: "SideBarPage",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => e.model.visible ? (l(), C(s(c), {
      key: 0,
      is: e.model.componentName,
      model: e.model.componentData
    }, null, 8, ["is", "model"])) : m("", !0);
  }
}), ro = /* @__PURE__ */ g({
  __name: "ObjectSelector",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => e.model.isVisible ? (l(), C(s(c), {
      key: 0,
      is: "sv-list",
      model: e.model.list
    }, null, 8, ["model"])) : m("", !0);
  }
}), uo = { class: "svc-scroll__container" }, X = /* @__PURE__ */ g({
  __name: "Scroll",
  setup(u) {
    const t = new we(), e = I();
    return B(() => {
      t.setRootElement(e.value);
    }), K(() => {
      t.setRootElement(void 0), t.unsubscribeRootElement();
    }), (o, n) => (l(), r("div", {
      ref_key: "root",
      ref: e,
      class: "svc-scroll__wrapper"
    }, [
      a("div", {
        class: "svc-scroll__scroller sv-drag-target-skipped",
        onScroll: n[0] || (n[0] = () => s(t).onScrollContainer())
      }, [
        a("div", uo, [
          Z(o.$slots, "default")
        ])
      ], 32),
      a("div", {
        class: "svc-scroll__scrollbar",
        onScroll: n[1] || (n[1] = () => s(t).onScrollScrollbar())
      }, n[2] || (n[2] = [
        a("div", { class: "svc-scroll__scrollbar-sizer" }, null, -1)
      ]), 32)
    ], 512));
  }
}), co = /* @__PURE__ */ g({
  __name: "PropertyGrid",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", {
      class: _(e.model.rootCss)
    }, [
      p(s(c), {
        is: "svc-search",
        model: e.model.searchManager
      }, null, 8, ["model"]),
      p(X, null, {
        default: Y(() => [
          e.model.survey ? (l(), C(s(Q), {
            key: 0,
            survey: e.model.survey
          }, null, 8, ["survey"])) : m("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), vo = /* @__PURE__ */ g({
  __name: "Tabs",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(!0), r($, null, R(e.model.actions, (n, i) => (l(), C(s(c), {
      key: i,
      is: "svc-tab-button",
      model: n
    }, null, 8, ["model"]))), 128));
  }
}), po = { class: "svc-sidebar-tabs__top-container" }, mo = { class: "svc-sidebar-tabs__collapse-button" }, _o = { class: "svc-sidebar-tabs__items" }, go = { class: "svc-sidebar-tabs__bottom-container" }, bo = { class: "svc-sidebar-tabs__items" }, yo = /* @__PURE__ */ g({
  __name: "TabControl",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", {
      class: _(e.model.sideBarClassName)
    }, [
      a("div", po, [
        a("div", mo, [
          p(s(c), {
            is: "svc-tab-button",
            model: e.model.expandCollapseAction
          }, null, 8, ["model"])
        ]),
        o[0] || (o[0] = a("div", { class: "svc-sidebar-tabs__separator" }, [
          a("div")
        ], -1)),
        a("div", _o, [
          p(s(c), {
            is: "svc-tabs",
            model: e.model.topToolbar
          }, null, 8, ["model"])
        ])
      ]),
      a("div", go, [
        a("div", bo, [
          p(s(c), {
            is: "svc-tabs",
            model: e.model.bottomToolbar
          }, null, 8, ["model"])
        ])
      ])
    ], 2));
  }
}), ho = { class: "svc-menu-action" }, qo = ["title"], Co = { class: "svc-menu-action__icon" }, wo = { class: "svc-menu-action__icon-container" }, ko = /* @__PURE__ */ g({
  __name: "TabButton",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => {
      const n = x("key2click");
      return l(), r("div", ho, [
        h((l(), r("div", {
          class: _(e.model.buttonClassName),
          title: e.model.tooltip,
          onClick: o[0] || (o[0] = (i) => e.model.action())
        }, [
          a("div", Co, [
            a("div", wo, [
              p(s(c), {
                is: "sv-svg-icon",
                iconName: e.model.iconName,
                size: "auto"
              }, null, 8, ["iconName"])
            ])
          ])
        ], 10, qo)), [
          [n, { processEsc: !1, disableTabStop: e.model.disableTabStop }]
        ])
      ]);
    };
  }
}), fo = { class: "svc-property-grid-placeholder" }, $o = { class: "svc-property-grid-placeholder__header" }, To = { class: "svc-property-grid-placeholder__title" }, Do = { class: "svc-property-grid-placeholder__description" }, No = /* @__PURE__ */ g({
  __name: "PropertyGridPlaceholder",
  setup(u) {
    const t = ce;
    return (e, o) => (l(), r("div", fo, [
      a("div", $o, [
        a("span", To, k(s(t).getString("ed.propertyGridPlaceholderTitle")), 1),
        a("span", Do, k(s(t).getString("ed.propertyGridPlaceholderDescription")), 1)
      ]),
      o[0] || (o[0] = a("div", { class: "svc-property-grid-placeholder__content" }, [
        a("div", { class: "svc-property-grid-placeholder__gap" }),
        a("div", { class: "svc-property-grid-placeholder__image" })
      ], -1))
    ]));
  }
}), Mo = { class: "svc-side-bar__container-header svc-sidebar__header-container" }, So = {
  key: 0,
  class: "svc-side-bar__container-title"
}, Eo = {
  key: 1,
  class: "svc-sidebar__header-caption"
}, Io = { class: "svc-sidebar__header-title" }, Bo = { class: "svc-sidebar__header-subtitle" }, Po = /* @__PURE__ */ g({
  __name: "SideBarHeader",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", Mo, [
      e.model.subTitle ? m("", !0) : (l(), r("div", So, k(e.model.title), 1)),
      e.model.subTitle ? (l(), r("div", Eo, [
        a("span", Io, k(e.model.title), 1),
        a("span", Bo, k(e.model.subTitle), 1)
      ])) : m("", !0)
    ]));
  }
}), Ro = { class: "svc-sidebar__header svc-sidebar__header--tabbed" }, Vo = { class: "svc-sidebar__header-container svc-sidebar__header-container--with-subtitle" }, zo = { class: "svc-sidebar__header-content" }, Ao = { class: "svc-sidebar__header-caption" }, Lo = { class: "svc-sidebar__header-title" }, Fo = { class: "svc-sidebar__header-subtitle" }, Ko = /* @__PURE__ */ g({
  __name: "SideBarPropertyGridHeader",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => {
      const n = x("key2click");
      return l(), r("div", Ro, [
        a("div", Vo, [
          a("div", zo, [
            h((l(), r("div", {
              class: _(e.model.buttonClassName),
              onClick: o[0] || (o[0] = (i) => e.model.action())
            }, [
              a("div", Ao, [
                a("span", Lo, k(e.model.title), 1),
                a("span", Fo, k(e.model.tooltip), 1)
              ])
            ], 2)), [
              [n, { processEsc: !1 }]
            ]),
            p(s(c), { is: "sv-popup" })
          ])
        ])
      ]);
    };
  }
}), Uo = /* @__PURE__ */ g({
  __name: "QuestionError",
  props: {
    errorKey: {},
    error: {},
    cssClasses: {},
    element: {}
  },
  setup(u) {
    return (t, e) => (l(), r("div", { key: t.errorKey }, [
      p(s(c), {
        is: "sv-svg-icon",
        class: _(t.cssClasses.error.icon),
        iconName: "icon-alert_24x24",
        size: "auto"
      }, null, 8, ["class"]),
      a("span", {
        class: _(
          t.cssClasses ? t.cssClasses.error.item || void 0 : "panel-error-item"
        )
      }, [
        p(s(c), {
          is: "survey-string",
          locString: t.error.locText
        }, null, 8, ["locString"])
      ], 2)
    ]));
  }
}), Ho = ["title"], Oo = ["title"], Qo = ["title"], Go = ["title"], Wo = /* @__PURE__ */ g({
  __name: "ActionButton",
  props: {
    classes: {},
    selected: { type: Boolean },
    disabled: { type: Boolean },
    text: {},
    title: {},
    allowBubble: { type: Boolean },
    click: { type: Function },
    iconName: {}
  },
  setup(u) {
    const t = u, e = (n) => {
      t.click(), t.allowBubble || n.stopPropagation();
    }, o = () => new he().append(t.classes || "").append("svc-action-button").append("svc-action-button--icon", !!t.iconName).append("svc-action-button--selected", !!t.selected).append("svc-action-button--disabled", !!t.disabled).toString();
    return (n, i) => (l(), r($, null, [
      n.iconName ? m("", !0) : (l(), r($, { key: 0 }, [
        n.disabled ? (l(), r("span", {
          key: 0,
          class: _(["svc-action-button svc-action-button--disabled", n.classes]),
          title: n.title
        }, k(n.text), 11, Ho)) : m("", !0),
        h((l(), r("span", {
          role: "button",
          class: _(["svc-action-button", o()]),
          onClick: e,
          title: n.title
        }, [
          ge(k(n.text), 1)
        ], 10, Oo)), [
          [s(N)]
        ])
      ], 64)),
      n.iconName ? (l(), r($, { key: 1 }, [
        n.disabled ? (l(), r("span", {
          key: 0,
          class: _(o()),
          title: n.title
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: n.iconName,
            size: "auto"
          }, null, 8, ["iconName"])
        ], 10, Qo)) : m("", !0),
        h((l(), r("span", {
          role: "button",
          onClick: e,
          class: _(o()),
          title: n.title
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: n.iconName,
            size: "auto"
          }, null, 8, ["iconName"])
        ], 10, Go)), [
          [s(N)]
        ])
      ], 64)) : m("", !0)
    ], 64));
  }
}), jo = ["disabled", "title", "aria-checked", "aria-expanded", "role"], Jo = {
  key: 0,
  class: "svc-switcher__title"
}, Zo = {
  inheritAttrs: !1
}, Xo = /* @__PURE__ */ g({
  ...Zo,
  __name: "Switcher",
  props: {
    item: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.item), (e, o) => h((l(), r("button", {
      class: _(e.item.getActionBarItemCss()),
      type: "button",
      onClick: o[0] || (o[0] = (n) => {
        e.item.action(e.item, !!n.pointerType);
      }),
      onKeyup: o[1] || (o[1] = (n) => {
        n.stopPropagation();
      }),
      disabled: e.item.disabled,
      title: e.item.tooltip || e.item.title,
      "aria-checked": e.item.ariaChecked,
      "aria-expanded": e.item.ariaExpanded,
      role: e.item.ariaRole
    }, [
      a("div", {
        class: _(e.item.getSwitcherIconCss())
      }, o[2] || (o[2] = [
        a("div", { class: "svc-switcher__icon-thumb" }, null, -1)
      ]), 2),
      e.item.hasTitle ? (l(), r("span", Jo, k(e.item.title), 1)) : m("", !0)
    ], 42, jo)), [
      [s(N), { processEsc: !1, disableTabStop: e.item.disableTabStop }]
    ]);
  }
}), Yo = {
  key: 0,
  class: "svd-simulator-content"
}, xo = { class: "svd-simulator-content" }, es = /* @__PURE__ */ g({
  __name: "Simulator",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    T(() => t.model);
    const e = w(() => t.model.simulatorFrame), o = () => {
      t.model.device !== "desktop" && t.model.activateZoom();
    }, n = () => {
      t.model.device !== "desktop" && t.model.deactivateZoom();
    };
    return (i, d) => (l(), r("div", {
      class: _(i.model.getRootCss()),
      onKeydown: d[0] || (d[0] = (v) => i.model.tryToZoom(void 0, v)),
      onMouseover: d[1] || (d[1] = (v) => o()),
      onMouseout: d[2] || (d[2] = (v) => n())
    }, [
      i.model.hasFrame ? m("", !0) : (l(), r("div", Yo, [
        p(s(c), {
          is: "survey-widget",
          model: i.model.survey
        }, null, 8, ["model"])
      ])),
      i.model.hasFrame ? (l(), r("div", {
        key: 1,
        class: "svd-simulator-wrapper",
        id: "svd-simulator-wrapper",
        style: F({
          width: e.value.frameWidth + "px",
          height: e.value.frameHeight + "px"
        })
      }, [
        a("div", {
          class: "svd-simulator",
          style: F({
            width: e.value.deviceWidth + "px",
            height: e.value.deviceHeight + "px",
            transform: "scale(" + e.value.scale + ") translate(-50%, -50%)"
          })
        }, [
          a("div", xo, [
            p(s(c), {
              is: "survey-widget",
              model: i.model.survey
            }, null, 8, ["model"])
          ])
        ], 4)
      ], 4)) : m("", !0)
    ], 34));
  }
}), os = { class: "svc-surface-placeholder" }, ss = { class: "svc-surface-placeholder__text" }, ts = { class: "svc-surface-placeholder__title" }, ns = { class: "svc-surface-placeholder__description" }, W = /* @__PURE__ */ g({
  __name: "SurfacePlaceholder",
  props: {
    name: {},
    placeholderTitleText: {},
    placeholderDescriptionText: {}
  },
  setup(u) {
    return (t, e) => (l(), r("div", os, [
      a("div", {
        class: _(["svc-surface-placeholder__image", "svc-surface-placeholder__image--" + t.name])
      }, null, 2),
      a("div", ss, [
        a("div", ts, k(t.placeholderTitleText), 1),
        a("div", ns, k(t.placeholderDescriptionText), 1)
      ])
    ]));
  }
}), ls = {
  key: 0,
  class: "svc-test-tab--empty"
}, is = {
  key: 2,
  class: "svc-plugin-tab__content-actions svc-test-tab__content-actions"
}, as = /* @__PURE__ */ g({
  __name: "Test",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", {
      class: _(["svc-creator-tab__content svc-test-tab__content", {
        "svc-creator-tab__content--with-toolbar": e.model.isPageToolbarVisible
      }])
    }, [
      e.model.survey.isEmpty ? (l(), r("div", ls, [
        p(W, {
          name: "preview",
          placeholderTitleText: e.model.placeholderTitleText,
          placeholderDescriptionText: e.model.placeholderDescriptionText
        }, null, 8, ["placeholderTitleText", "placeholderDescriptionText"])
      ])) : m("", !0),
      e.model.survey.isEmpty ? m("", !0) : (l(), r("div", {
        key: 1,
        class: "svc-plugin-tab__content",
        onScroll: o[0] || (o[0] = (n) => e.model.onScroll())
      }, [
        p(s(c), {
          is: "survey-simulator",
          model: e.model.simulator
        }, null, 8, ["model"]),
        e.model.showResults ? (l(), C(s(c), {
          key: 0,
          is: "survey-results",
          survey: e.model.survey
        }, null, 8, ["survey"])) : m("", !0)
      ], 32)),
      e.model.isPageToolbarVisible ? (l(), r("div", is, [
        p(s(c), {
          is: "sv-action-bar",
          model: e.model.pages
        }, null, 8, ["model"])
      ])) : m("", !0)
    ], 2));
  }
}), rs = { class: "svc-btn__text" }, ds = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "TestAgain",
  props: {
    model: {}
  },
  setup(u) {
    const t = u, e = w(() => t.model.testAgainAction);
    return T(() => e.value), (o, n) => h((l(), r("div", {
      role: "button",
      class: "svc-preview__test-again svc-btn",
      onClick: n[0] || (n[0] = (i) => e.value.action())
    }, [
      a("span", rs, k(e.value.title), 1)
    ])), [
      [s(N)]
    ]);
  }
});
function z(u, t, e) {
  const o = be(), n = G(
    t.map((i) => () => i()),
    () => {
      o.value = u();
    },
    {
      immediate: !0
    }
  );
  return T(() => o.value, void 0, e), ee(() => {
    n();
  }), o;
}
const us = {
  key: 0,
  class: "svd-test-results"
}, cs = { class: "svd-test-results__content" }, vs = { class: "svd-test-results__header" }, ps = { class: "svd-test-results__header-text" }, ms = { class: "svd-test-results__header-types" }, _s = { class: "svd-test-results__text svd-light-bg-color" }, gs = { class: "svd-test-results__table svd-light-bg-color" }, bs = { class: "svd-light-background-color" }, ys = { class: "svd-dark-border-color" }, hs = { class: "svd-dark-border-color" }, qs = /* @__PURE__ */ g({
  __name: "SurveyResults",
  props: {
    survey: {}
  },
  setup(u) {
    const t = u, e = z(
      () => t.survey ? new ke(t.survey) : void 0,
      [() => t.survey]
    );
    return (o, n) => s(e) ? (l(), r("div", us, [
      a("div", cs, [
        a("div", vs, [
          a("div", ps, k(s(e).surveyResultsText), 1),
          a("div", ms, [
            p(s(c), {
              is: "svc-action-button",
              text: s(e).surveyResultsTableText,
              click: s(e).selectTableClick,
              disabled: !1,
              selected: s(e).isTableSelected
            }, null, 8, ["text", "click", "selected"]),
            p(s(c), {
              is: "svc-action-button",
              text: s(e).surveyResultsJsonText,
              click: s(e).selectJsonClick,
              disabled: !1,
              selected: s(e).isJsonSelected
            }, null, 8, ["text", "click", "selected"])
          ])
        ]),
        h(a("div", _s, [
          a("div", null, k(s(e).resultText), 1)
        ], 512), [
          [L, s(e).resultViewType === "text"]
        ]),
        h(a("div", gs, [
          a("table", null, [
            a("thead", null, [
              a("tr", bs, [
                a("th", ys, k(s(e).resultsTitle), 1),
                a("th", hs, k(s(e).resultsDisplayValue), 1)
              ])
            ]),
            a("tbody", null, [
              (l(!0), r($, null, R(s(e).resultData, (i, d) => (l(), C(s(c), {
                is: "survey-results-table-row",
                model: i,
                key: d
              }, null, 8, ["model"]))), 128))
            ])
          ])
        ], 512), [
          [L, s(e).resultViewType === "table"]
        ])
      ])
    ])) : m("", !0);
  }
}), Cs = { key: 2 }, ws = /* @__PURE__ */ g({
  __name: "SurveyResultsRow",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r($, null, [
      h((l(), r("tr", {
        onClick: o[0] || (o[0] = (...n) => e.model.toggle && e.model.toggle(...n))
      }, [
        a("td", {
          class: "svd-dark-border-color",
          style: F({ paddingLeft: e.model.textMargin })
        }, [
          e.model.isNode ? (l(), r("span", {
            key: 0,
            class: _(["svd-test-results__marker", { "svd-test-results__marker--expanded": !e.model.collapsed }]),
            style: F({ left: e.model.markerMargin })
          }, [
            p(s(c), {
              is: "sv-svg-icon",
              iconName: "icon-expand_16x16",
              size: 16
            })
          ], 6)) : m("", !0),
          e.model.question ? (l(), C(s(c), {
            key: 1,
            is: "survey-string",
            locString: e.model.question.locTitle
          }, null, 8, ["locString"])) : (l(), r("span", Cs, k(e.model.title), 1))
        ], 4),
        a("td", {
          class: _({
            "svd-test-results__node-value": e.model.isNode,
            "svd-dark-border-color": !e.model.isNode
          })
        }, k(e.model.getString(e.model.displayValue)), 3)
      ])), [
        [s(N)]
      ]),
      e.model.isNode && !e.model.collapsed ? (l(!0), r($, { key: 0 }, R(e.model.data, (n, i) => (l(), C(s(c), {
        is: "survey-results-table-row",
        model: n,
        key: i + 1
      }, null, 8, ["model"]))), 128)) : m("", !0)
    ], 64));
  }
}), ks = { class: "svc-creator-tab__content" }, fs = { class: "svc-json-editor-tab__content" }, $s = { class: "svc-json-editor-tab__errros_list" }, Ts = /* @__PURE__ */ g({
  __name: "JsonEditorAce",
  props: {
    model: {}
  },
  setup(u) {
    const t = u, e = I();
    return T(() => t.model), B(() => t.model.init(window.ace.edit(e.value))), (o, n) => (l(), r("div", ks, [
      a("div", fs, [
        a("div", {
          class: "svc-json-editor-tab__ace-editor",
          ref_key: "inputEl",
          ref: e
        }, null, 512),
        h(a("div", $s, [
          p(s(c), {
            is: "sv-list",
            model: o.model.errorList
          }, null, 8, ["model"])
        ], 512), [
          [L, o.model.hasErrors]
        ])
      ])
    ]));
  }
}), Ds = { class: "svc-creator-tab__content" }, Ns = { class: "svc-json-editor-tab__content" }, Ms = ["aria-label", "disabled"], Ss = { class: "svc-json-editor-tab__errros_list" }, Es = /* @__PURE__ */ g({
  __name: "JsonEditorTextArea",
  props: {
    model: {}
  },
  setup(u) {
    const t = u, e = I(), o = t.model;
    return o.canShowErrors = !1, T(() => t.model), B(() => {
      const n = t.model;
      n.textElement = e.value;
    }), (n, i) => (l(), r("div", Ds, [
      a("div", Ns, [
        h(a("textarea", {
          class: "svc-json-editor-tab__content-area",
          "aria-label": s(o).ariaLabel,
          disabled: s(o).readOnly,
          "onUpdate:modelValue": i[0] || (i[0] = (d) => s(o).text = d),
          onKeydown: i[1] || (i[1] = (d) => s(o).checkKey(s(o), d)),
          ref_key: "inputEl",
          ref: e
        }, "      ", 40, Ms), [
          [de, s(o).text]
        ]),
        h(a("div", Ss, [
          p(s(c), {
            is: "sv-list",
            model: s(o).errorList
          }, null, 8, ["model"])
        ], 512), [
          [L, s(o).hasErrors]
        ])
      ])
    ]));
  }
}), Is = { class: "svc-json-error__container" }, Bs = { class: "svc-json-error__title" }, Ps = ["title", "aria-label"], Rs = /* @__PURE__ */ g({
  __name: "JsonEditorErrorItem",
  props: {
    item: {}
  },
  setup(u) {
    const t = u;
    T(() => t.item);
    const e = (o) => {
      o.stopPropagation(), t.item.data.fixError();
    };
    return (o, n) => (l(), r($, null, [
      p(s(c), {
        is: "sv-svg-icon",
        iconName: o.item.iconName,
        size: o.item.iconSize,
        class: _("svc-json-error__icon")
      }, null, 8, ["iconName", "size"]),
      a("div", Is, [
        a("div", Bs, [
          p(s(c), {
            is: "survey-string",
            locString: o.item.locTitle
          }, null, 8, ["locString"])
        ]),
        o.item.data.showFixButton ? h((l(), r("button", {
          key: 0,
          type: "button",
          onClick: e,
          title: o.item.data.fixButtonTitle,
          "aria-label": o.item.data.fixButtonTitle,
          class: "svc-json-error__fix-button"
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: o.item.data.fixButtonIcon,
            size: "auto"
          }, null, 8, ["iconName"])
        ], 8, Ps)), [
          [s(N)]
        ]) : m("", !0)
      ])
    ], 64));
  }
}), Vs = { class: "svc-btn__text" }, zs = /* @__PURE__ */ g({
  __name: "LogicAddButton",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    T(() => t.model);
    const e = (o) => {
      o.stopPropagation(), t.model.action();
    };
    return (o, n) => h((l(), r("div", {
      role: "button",
      class: _(["svc-logic-tab__content-action svc-btn", {
        "svc-logic-tab__content-action--disabled": o.model.enabled !== void 0 && !o.model.enabled
      }]),
      onClick: e
    }, [
      a("span", Vs, k(o.model.title), 1)
    ], 2)), [
      [s(N)]
    ]);
  }
}), As = { class: "svc-creator-tab__content" }, Ls = {
  key: 0,
  class: "svc-logic-tab__content-empty"
}, Fs = /* @__PURE__ */ g({
  __name: "Logic",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", As, [
      a("div", {
        class: _(["svc-plugin-tab__content svc-logic-tab__content", { "svc-logic-tab--empty": !e.model.hasItems }])
      }, [
        p(s(Q), {
          model: e.model.itemsSurvey
        }, null, 8, ["model"]),
        e.model.hasItems ? m("", !0) : (l(), r("div", Ls, [
          p(W, {
            name: "logic",
            placeholderTitleText: e.model.placeholderTitleText,
            placeholderDescriptionText: e.model.placeholderDescriptionText
          }, null, 8, ["placeholderTitleText", "placeholderDescriptionText"])
        ])),
        e.model.readOnly ? m("", !0) : (l(), C(zs, {
          key: 1,
          model: e.model.addNewButton
        }, null, 8, ["model"]))
      ], 2)
    ]));
  }
}), Ks = ["id", "required", "tabindex", "disabled", "role", "aria-required", "aria-label", "aria-invalid", "aria-describedby"], Us = ["id"];
ue.Instance.registerRenderer(
  "dropdown",
  "logicoperator",
  "sv-logic-operator"
);
const Hs = /* @__PURE__ */ g({
  __name: "LogicOperator",
  props: {
    question: {}
  },
  setup(u) {
    const t = u, e = I(), o = w(() => {
      var v;
      return (v = t.question.dropdownListModel) != null ? v : new qe(t.question);
    });
    H(t, e, (v) => {
      fe(v);
    });
    const n = (v) => {
      var b;
      (b = o.value) == null || b.onClick(v);
    }, i = (v) => {
      var b;
      (b = o.value) == null || b.onClear(v);
    }, d = (v) => {
      var b;
      (b = o.value) == null || b.keyHandler(v);
    };
    return (v, b) => (l(), r("div", {
      class: _(v.question.cssClasses.selectWrapper)
    }, [
      v.question.isReadOnly ? m("", !0) : (l(), r($, { key: 0 }, [
        a("div", {
          class: _(v.question.getControlClass()),
          onClick: n,
          onKeyup: d,
          id: v.question.inputId,
          required: v.question.isRequired,
          tabindex: v.question.isInputReadOnly ? void 0 : 0,
          disabled: v.question.isInputReadOnly,
          role: v.question.ariaRole,
          "aria-required": v.question.ariaRequired,
          "aria-label": v.question.ariaLabel,
          "aria-invalid": v.question.ariaInvalid,
          "aria-describedby": v.question.ariaDescribedBy
        }, [
          a("div", {
            class: _(v.question.cssClasses.controlValue)
          }, [
            v.question.selectedItemLocText ? (l(), C(s(c), {
              key: 0,
              is: "survey-string",
              locString: v.question.selectedItemLocText
            }, null, 8, ["locString"])) : m("", !0),
            a("div", null, k(v.question.readOnlyText), 1)
          ], 2),
          v.question.allowClear && v.question.cssClasses.cleanButtonIconId ? h((l(), r("div", {
            key: 0,
            class: _(v.question.cssClasses.cleanButton),
            onClick: i
          }, [
            p(s(c), {
              is: "sv-svg-icon",
              class: _(v.question.cssClasses.cleanButtonSvg),
              iconName: v.question.cssClasses.cleanButtonIconId,
              size: "auto",
              title: v.question.clearCaption
            }, null, 8, ["class", "iconName", "title"])
          ], 2)), [
            [L, !v.question.isEmpty()]
          ]) : m("", !0)
        ], 42, Ks),
        p(s(c), {
          is: "sv-popup",
          model: v.question.popupModel
        }, null, 8, ["model"])
      ], 64)),
      v.question.isReadOnly ? (l(), r("div", {
        key: 1,
        disabled: "",
        class: _(v.question.getControlClass()),
        id: v.question.inputId
      }, [
        v.question.selectedItemLocText ? (l(), C(s(c), {
          key: 0,
          is: "survey-string",
          locString: v.question.selectedItemLocText
        }, null, 8, ["locString"])) : m("", !0),
        a("div", null, k(v.question.readOnlyText), 1)
      ], 10, Us)) : m("", !0)
    ], 2));
  }
}), Os = /* @__PURE__ */ g({
  __name: "EmbeddedSurvey",
  props: {
    question: {}
  },
  setup(u) {
    const t = u, e = I();
    H(t, e);
    const o = w(() => t.question.embeddedSurvey);
    return (n, i) => !!n.question && !!o.value && o.value.currentPage ? (l(), C(s(c), {
      key: 0,
      is: "survey-page",
      page: o.value.currentPage,
      survey: o.value
    }, null, 8, ["page", "survey"])) : m("", !0);
  }
}), Qs = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "LinkValue",
  props: {
    question: {}
  },
  setup(u) {
    const t = u, e = I(), o = ce.getString("pe.clear");
    return H(t, e), (n, i) => (l(), r($, null, [
      p(s(c), {
        is: "svc-action-button",
        text: n.question.linkValueText,
        click: n.question.doLinkClick.bind(n.question),
        selected: n.question.isSelected,
        disabled: !n.question.isClickable,
        classes: n.question.linkSetButtonCssClasses,
        title: n.question.tooltip,
        iconName: n.question.iconName
      }, null, 8, ["text", "click", "selected", "disabled", "classes", "title", "iconName"]),
      !n.question.isReadOnly && n.question.showClear ? (l(), C(s(c), {
        key: 0,
        is: "svc-action-button",
        text: s(o),
        click: n.question.doClearClick.bind(n.question),
        selected: n.question.isSelected,
        disabled: !1,
        classes: n.question.linkClearButtonCssClasses
      }, null, 8, ["text", "click", "selected", "classes"])) : m("", !0)
    ], 64));
  }
}), Gs = {
  key: 1,
  class: "st-content"
}, Ws = { class: "svc-flex-column st-strings-wrapper" }, js = { class: "svc-flex-row st-strings-header" }, Js = { class: "svc-flex-row svc-plugin-tab__content st-strings" }, Zs = /* @__PURE__ */ g({
  __name: "Translation",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", {
      class: _(["svc-creator-tab__content svc-translation-tab", e.model.isEmpty ? "svc-translation-tab--empty" : ""])
    }, [
      e.model.isEmpty ? (l(), C(W, {
        key: 0,
        name: "translation",
        placeholderTitleText: e.model.placeholderTitleText,
        placeholderDescriptionText: e.model.placeholderDescriptionText
      }, null, 8, ["placeholderTitleText", "placeholderDescriptionText"])) : m("", !0),
      e.model.isEmpty ? m("", !0) : (l(), r("div", Gs, [
        a("div", Ws, [
          a("div", js, [
            p(s(Q), {
              model: e.model.stringsHeaderSurvey
            }, null, 8, ["model"])
          ]),
          a("div", Js, [
            p(s(Q), {
              model: e.model.stringsSurvey
            }, null, 8, ["model"])
          ])
        ])
      ]))
    ], 2));
  }
}), Xs = (u, t) => {
  const e = u.__vccOpts || u;
  for (const [o, n] of t)
    e[o] = n;
  return e;
}, Ys = {}, xs = { class: "sd-translation-line-skeleton" };
function et(u, t) {
  return l(), r("div", xs);
}
const ot = /* @__PURE__ */ Xs(Ys, [["render", et]]), st = /* @__PURE__ */ g({
  __name: "TranslateFromAction",
  props: {
    item: {}
  },
  setup(u) {
    return (t, e) => (l(), r("div", {
      class: _(t.item.data.containerCss)
    }, [
      a("span", {
        class: _(t.item.data.additionalTitleCss)
      }, k(t.item.data.additionalTitle), 3),
      p(s(c), {
        is: "sv-action-bar-item-dropdown",
        item: t.item
      }, null, 8, ["item"])
    ], 2));
  }
}), tt = {
  key: 0,
  class: "svc-test-tab--empty"
}, nt = {
  key: 1,
  class: "svc-plugin-tab__content"
}, lt = {
  key: 2,
  class: "svc-plugin-tab__content-actions svc-test-tab__content-actions"
}, it = /* @__PURE__ */ g({
  __name: "Theme",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.model), (e, o) => (l(), r("div", {
      class: _(["svc-creator-tab__content svc-test-tab__content", {
        "svc-creator-tab__content--with-toolbar": e.model.isPageToolbarVisible
      }])
    }, [
      e.model.survey.isEmpty ? (l(), r("div", tt, [
        p(W, {
          name: "theme",
          placeholderTitleText: e.model.placeholderTitleText,
          placeholderDescriptionText: e.model.placeholderDescriptionText
        }, null, 8, ["placeholderTitleText", "placeholderDescriptionText"])
      ])) : m("", !0),
      e.model.survey.isEmpty ? m("", !0) : (l(), r("div", nt, [
        p(s(c), {
          is: "survey-simulator",
          model: e.model.simulator
        }, null, 8, ["model"]),
        e.model.showResults ? (l(), C(s(c), {
          key: 0,
          is: "survey-results",
          survey: e.model.survey
        }, null, 8, ["survey"])) : m("", !0)
      ])),
      e.model.isPageToolbarVisible ? (l(), r("div", lt, [
        p(s(c), {
          is: "sv-action-bar",
          model: e.model.pages
        }, null, 8, ["model"])
      ])) : m("", !0)
    ], 2));
  }
}), at = ["disabled", "value"], rt = ["disabled", "id", "placeholder", "aria-required", "aria-label", "aria-invalid", "aria-describedby", "value"], dt = /* @__PURE__ */ g({
  __name: "Color",
  props: {
    question: {}
  },
  setup(u) {
    return H(u, I()), (e, o) => (l(), r("div", {
      class: _(e.question.cssClasses.root),
      onKeydown: o[5] || (o[5] = (...n) => e.question.onKeyDown && e.question.onKeyDown(...n))
    }, [
      a("label", {
        class: _(e.question.getSwatchCss()),
        style: F(e.question.getSwatchStyle())
      }, [
        p(s(c), {
          is: "sv-svg-icon",
          iconName: e.question.cssClasses.swatchIcon,
          size: "auto"
        }, null, 8, ["iconName"]),
        a("input", {
          type: "color",
          disabled: e.question.isInputReadOnly,
          class: _(e.question.cssClasses.colorInput),
          value: e.question.renderedColorValue,
          tabindex: "-1",
          onChange: o[0] || (o[0] = (...n) => e.question.onColorInputChange && e.question.onColorInputChange(...n))
        }, null, 42, at)
      ], 6),
      a("input", {
        autocomplete: "off",
        disabled: e.question.isInputReadOnly,
        id: e.question.inputId,
        placeholder: e.question.renderedPlaceholder,
        "aria-required": e.question.ariaRequired,
        "aria-label": e.question.ariaLabel,
        "aria-invalid": e.question.ariaInvalid,
        "aria-describedby": e.question.ariaDescribedBy,
        onChange: o[1] || (o[1] = (...n) => e.question.onChange && e.question.onChange(...n)),
        onKeyup: o[2] || (o[2] = (...n) => e.question.onKeyUp && e.question.onKeyUp(...n)),
        onBlur: o[3] || (o[3] = (...n) => e.question.onBlur && e.question.onBlur(...n)),
        onBeforeinput: o[4] || (o[4] = (...n) => e.question.onBeforeInput && e.question.onBeforeInput(...n)),
        value: e.question.renderedValue,
        class: _(e.question.cssClasses.control)
      }, null, 42, rt),
      e.question.showDropdownAction ? (l(), r($, { key: 0 }, [
        p(s(c), {
          is: "sv-action-bar-item",
          item: e.question.dropdownAction
        }, null, 8, ["item"]),
        p(s(c), {
          is: "sv-popup",
          model: e.question.dropdownAction.popupModel
        }, null, 8, ["model"])
      ], 64)) : m("", !0)
    ], 34));
  }
}), ut = /* @__PURE__ */ g({
  __name: "ColorItem",
  props: {
    item: {}
  },
  setup(u) {
    const t = u;
    T(() => t.item);
    const e = () => ({ backgroundColor: t.item.value });
    return (o, n) => (l(), r($, null, [
      a("span", {
        class: "spg-color-editor__color-swatch",
        style: F(e())
      }, null, 4),
      p(s(c), {
        is: "survey-string",
        locString: o.item.locTitle
      }, null, 8, ["locString"])
    ], 64));
  }
}), ct = ["disabled", "value", "placeholder"], vt = ["disabled", "id", "aria-required", "aria-label", "aria-invalid", "aria-describedby", "title", "accept"], pt = ["disabled"], mt = ["for", "aria-label"], _t = /* @__PURE__ */ g({
  __name: "File",
  props: {
    question: {}
  },
  setup(u) {
    const t = I();
    return H(u, t), (o, n) => (l(), r("div", {
      class: _(o.question.cssClasses.root),
      onDragenter: n[5] || (n[5] = (...i) => o.question.onDragEnter && o.question.onDragEnter(...i)),
      onDragover: n[6] || (n[6] = (...i) => o.question.onDragOver && o.question.onDragOver(...i)),
      onDrop: n[7] || (n[7] = (...i) => o.question.onDrop && o.question.onDrop(...i)),
      onDragleave: n[8] || (n[8] = (...i) => o.question.onDragLeave && o.question.onDragLeave(...i)),
      onKeydown: n[9] || (n[9] = (...i) => o.question.onKeyDown && o.question.onKeyDown(...i)),
      ref_key: "root",
      ref: t
    }, [
      a("input", {
        type: "text",
        disabled: o.question.isInputReadOnly,
        class: _(o.question.cssClasses.control),
        value: o.question.renderedValue || "",
        onChange: n[0] || (n[0] = (...i) => o.question.onInputChange && o.question.onInputChange(...i)),
        onBlur: n[1] || (n[1] = (...i) => o.question.onInputBlur && o.question.onInputBlur(...i)),
        placeholder: o.question.renderedPlaceholder
      }, null, 42, ct),
      a("input", {
        type: "file",
        disabled: o.question.isInputReadOnly,
        class: _(o.question.cssClasses.fileInput),
        id: o.question.inputId,
        "aria-required": o.question.ariaRequired,
        "aria-label": o.question.ariaLabel,
        "aria-invalid": o.question.ariaInvalid,
        "aria-describedby": o.question.ariaDescribedBy,
        multiple: !1,
        title: o.question.inputTitle,
        tabindex: -1,
        accept: o.question.acceptedTypes,
        onChange: n[2] || (n[2] = (...i) => o.question.onFileInputChange && o.question.onFileInputChange(...i))
      }, null, 42, vt),
      a("div", {
        class: _(o.question.cssClasses.buttonsContainer)
      }, [
        h((l(), r("button", {
          type: "button",
          class: _(o.question.cssClasses.clearButton),
          disabled: o.question.getIsClearButtonDisabled(),
          onClick: n[3] || (n[3] = (...i) => o.question.doClean && o.question.doClean(...i))
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: o.question.cssClasses.clearButtonIcon,
            size: "auto",
            title: o.question.clearButtonCaption
          }, null, 8, ["iconName", "title"])
        ], 10, pt)), [
          [s(N)]
        ]),
        h((l(), r("label", {
          role: "button",
          class: _(o.question.getChooseButtonCss()),
          for: o.question.inputId,
          "aria-label": o.question.chooseButtonCaption,
          onClick: n[4] || (n[4] = (...i) => o.question.chooseFiles && o.question.chooseFiles(...i))
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: o.question.cssClasses.chooseButtonIcon,
            size: "auto",
            title: o.question.chooseButtonCaption
          }, null, 8, ["iconName", "title"])
        ], 10, mt)), [
          [s(N)]
        ])
      ], 2)
    ], 34));
  }
}), gt = ["disabled", "id", "placeholder", "aria-required", "aria-label", "aria-invalid", "aria-describedby", "value"], bt = ["disabled"], yt = ["disabled"], ht = /* @__PURE__ */ g({
  __name: "SpinEditor",
  props: {
    question: {}
  },
  setup(u) {
    return H(u, I()), (e, o) => (l(), r("div", {
      class: _(e.question.cssClasses.root),
      onKeydown: o[16] || (o[16] = (...n) => e.question.onKeyDown && e.question.onKeyDown(...n))
    }, [
      a("input", {
        autocomplete: "off",
        disabled: e.question.isInputReadOnly,
        id: e.question.inputId,
        placeholder: e.question.renderedPlaceholder,
        "aria-required": e.question.ariaRequired,
        "aria-label": e.question.ariaLabel,
        "aria-invalid": e.question.ariaInvalid,
        "aria-describedby": e.question.ariaDescribedBy,
        onChange: o[0] || (o[0] = (...n) => e.question.onChange && e.question.onChange(...n)),
        onKeydown: o[1] || (o[1] = (...n) => e.question.onInputKeyDown && e.question.onInputKeyDown(...n)),
        onKeyup: o[2] || (o[2] = (...n) => e.question.onKeyUp && e.question.onKeyUp(...n)),
        onBlur: o[3] || (o[3] = (...n) => e.question.onBlur && e.question.onBlur(...n)),
        onFocus: o[4] || (o[4] = (...n) => e.question.onFocus && e.question.onFocus(...n)),
        onBeforeinput: o[5] || (o[5] = (...n) => e.question.onBeforeInput && e.question.onBeforeInput(...n)),
        value: e.question.renderedValue,
        class: _(e.question.cssClasses.control)
      }, null, 42, gt),
      a("span", {
        class: _(e.question.cssClasses.buttonsContainer)
      }, [
        a("button", {
          disabled: e.question.isInputReadOnly,
          class: _(e.question.cssClasses.arrowButton),
          onMousedown: o[6] || (o[6] = (...n) => e.question.onDownButtonMouseDown && e.question.onDownButtonMouseDown(...n)),
          onMouseup: o[7] || (o[7] = (...n) => e.question.onButtonMouseUp && e.question.onButtonMouseUp(...n)),
          onMouseleave: o[8] || (o[8] = (...n) => e.question.onButtonMouseLeave && e.question.onButtonMouseLeave(...n)),
          onBlur: o[9] || (o[9] = (...n) => e.question.onBlur && e.question.onBlur(...n)),
          onFocus: o[10] || (o[10] = (...n) => e.question.onFocus && e.question.onFocus(...n)),
          tabindex: "-1"
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: e.question.cssClasses.decreaseButtonIcon,
            size: "auto"
          }, null, 8, ["iconName"])
        ], 42, bt),
        a("button", {
          disabled: e.question.isInputReadOnly,
          class: _(e.question.cssClasses.arrowButton),
          onMousedown: o[11] || (o[11] = (...n) => e.question.onUpButtonMouseDown && e.question.onUpButtonMouseDown(...n)),
          onMouseup: o[12] || (o[12] = (...n) => e.question.onButtonMouseUp && e.question.onButtonMouseUp(...n)),
          onMouseleave: o[13] || (o[13] = (...n) => e.question.onButtonMouseLeave && e.question.onButtonMouseLeave(...n)),
          onBlur: o[14] || (o[14] = (...n) => e.question.onBlur && e.question.onBlur(...n)),
          onFocus: o[15] || (o[15] = (...n) => e.question.onFocus && e.question.onFocus(...n)),
          tabindex: "-1"
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: e.question.cssClasses.increaseButtonIcon,
            size: "auto"
          }, null, 8, ["iconName"])
        ], 42, yt)
      ], 2)
    ], 34));
  }
}), qt = ["disabled", "title"], le = /* @__PURE__ */ g({
  __name: "TextWithReset",
  props: {
    question: {}
  },
  setup(u) {
    const t = u, e = () => "survey-" + t.question.wrappedQuestionTemplate;
    return H(t, I()), (o, n) => (l(), r("div", {
      class: _(o.question.getRootClass())
    }, [
      p(s(c), {
        is: e(),
        question: o.question
      }, null, 8, ["is", "question"]),
      a("button", {
        class: _(o.question.cssClasses.resetButton),
        disabled: o.question.resetValueAdorner.isDisabled,
        onClick: n[0] || (n[0] = (...i) => o.question.resetValueAdorner.resetValue && o.question.resetValueAdorner.resetValue(...i)),
        title: o.question.resetValueAdorner.caption
      }, [
        p(s(c), {
          is: "sv-svg-icon",
          iconName: o.question.cssClasses.resetButtonIcon,
          size: "auto"
        }, null, 8, ["iconName"])
      ], 10, qt)
    ], 2));
  }
}), Ct = ["aria-required", "aria-label", "aria-invalid", "aria-errormessage"], wt = { class: "spg-boolean-switch__caption" }, kt = { class: "spg-boolean-switch__title" };
ue.Instance.registerRenderer(
  "boolean",
  "switch",
  "sv-boolean-switch"
);
const ft = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "BooleanSwitch",
  props: {
    question: {}
  },
  setup(u) {
    const t = u, e = I(null);
    return H(t, e), (o, n) => {
      const i = x("key2click");
      return l(), r("div", {
        class: "spg-boolean-switch",
        role: "checkbox",
        "aria-required": o.question.ariaRequired,
        "aria-label": o.question.ariaLabel,
        "aria-invalid": o.question.ariaInvalid,
        "aria-errormessage": o.question.ariaErrormessage,
        onClick: n[0] || (n[0] = (d) => o.question.value = !o.question.value)
      }, [
        h((l(), r("div", {
          class: _(["spg-boolean-switch__button", o.question.value ? "spg-boolean-switch__button--checked" : ""]),
          tabindex: "0"
        }, n[1] || (n[1] = [
          a("div", { class: "spg-boolean-switch__thumb" }, [
            a("div", { class: "spg-boolean-switch__thumb-circle spg-boolean-switch__thumb--left" })
          ], -1),
          a("div", { class: "spg-boolean-switch__thumb" }, [
            a("div", { class: "spg-boolean-switch__thumb-circle spg-boolean-switch__thumb--right" })
          ], -1)
        ]), 2)), [
          [i, { disableTabStop: !0 }]
        ]),
        a("div", wt, [
          a("div", kt, [
            p(s(c), {
              is: "survey-string",
              locString: o.question.locTitle
            }, null, 8, ["locString"])
          ])
        ])
      ], 8, Ct);
    };
  }
}), $t = { class: "svc-string-editor__content" }, Tt = { class: "svc-string-editor__input" }, Dt = ["textContent", "aria-placeholder", "contenteditable"], Nt = ["aria-placeholder", "contenteditable", "innerHTML"], Mt = {
  key: 0,
  class: "svc-string-editor__error"
}, St = /* @__PURE__ */ g({
  __name: "StringEditor",
  props: {
    locString: {}
  },
  setup(u) {
    const t = u, e = w(() => t.locString.locStr), o = w(() => t.locString.creator), n = I(), i = I(), d = z(
      () => {
        const q = new $e(
          e.value,
          o.value
        );
        return q.setLocString(e.value), q.blurEditor = () => {
          n.value && (n.value.blur(), n.value.spellcheck = !1);
        }, q.getEditorElement = () => n.value, setTimeout(() => q.afterRender()), q;
      },
      [() => o.value, () => e.value],
      (q) => {
        q && (q.blurEditor = void 0, q.getEditorElement = void 0, q.dispose());
      }
    ), v = w(() => {
      var q;
      return (q = d.value) == null ? void 0 : q.errorText;
    }), b = w(() => {
      var q;
      return (q = d.value) == null ? void 0 : q.className(e.value.renderedHtml);
    }), y = w(() => {
      var q;
      return (q = d.value) == null ? void 0 : q.placeholder;
    }), D = w(() => {
      var q;
      return (q = d.value) == null ? void 0 : q.contentEditable;
    }), O = w(() => {
      var q;
      return (q = d.value) == null ? void 0 : q.characterCounter;
    }), P = w(
      () => {
        var q;
        return (q = d.value) == null ? void 0 : q.showCharacterCounter;
      }
    ), A = w(
      () => {
        var q;
        return (q = d.value) == null ? void 0 : q.getCharacterCounterClass;
      }
    ), j = (q) => {
      var f, E;
      return n.value && (n.value.spellcheck = !1), e.value.__isEditing = !1, (f = d.value) == null || f.onBlur(q), (E = d.value) == null ? void 0 : E.errorText;
    }, U = (q) => {
      var f;
      (f = d.value) == null || f.onFocus(q);
    }, pe = (q) => {
      var f;
      (f = d.value) == null || f.onPaste(q);
    }, ne = (q) => {
      var f, E;
      (f = n.value) == null || f.focus(), e.value.__isEditing = !0, (E = d.value) == null || E.onClick(q);
    }, J = () => {
      i.value = e.value.renderedHtml;
    }, me = G(
      () => e.value,
      (q, f) => {
        f && q.onStringChanged.remove(J), q && (q.onStringChanged.add(J), J());
      },
      {
        immediate: !0
      }
    );
    return B(() => {
      var q;
      e.value.__isEditing && ((q = n.value) == null || q.focus());
    }), K(() => {
      me(), e.value.onStringChanged.remove(J);
    }), (q, f) => (l(), r("span", {
      class: _(b.value)
    }, [
      a("span", $t, [
        f[11] || (f[11] = a("div", { class: "svc-string-editor__border svc-string-editor__border--hover" }, null, -1)),
        f[12] || (f[12] = a("div", { class: "svc-string-editor__border svc-string-editor__border--focus" }, null, -1)),
        a("span", Tt, [
          e.value.hasHtml ? m("", !0) : (l(), r("span", {
            key: 0,
            role: "textbox",
            class: "sv-string-editor",
            spellcheck: "false",
            onFocus: U,
            onPaste: pe,
            onBlur: j,
            onInput: f[0] || (f[0] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onInput) && ((S = s(d)) == null ? void 0 : S.onInput(...E));
            }),
            onKeydown: f[1] || (f[1] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onKeyDown) && ((S = s(d)) == null ? void 0 : S.onKeyDown(...E));
            }),
            onKeyup: f[2] || (f[2] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onKeyUp) && ((S = s(d)) == null ? void 0 : S.onKeyUp(...E));
            }),
            onCompositionstart: f[3] || (f[3] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onCompositionStart) && ((S = s(d)) == null ? void 0 : S.onCompositionStart(...E));
            }),
            onCompositionend: f[4] || (f[4] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onCompositionEnd) && ((S = s(d)) == null ? void 0 : S.onCompositionEnd(...E));
            }),
            onMouseup: f[5] || (f[5] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onMouseUp) && ((S = s(d)) == null ? void 0 : S.onMouseUp(...E));
            }),
            onClick: ne,
            textContent: i.value,
            "aria-placeholder": y.value,
            contenteditable: D.value,
            ref_key: "root",
            ref: n
          }, null, 40, Dt)),
          e.value.hasHtml ? (l(), r("span", {
            key: 1,
            role: "textbox",
            class: "sv-string-editor sv-string-editor--html",
            spellcheck: "false",
            onFocus: U,
            onBlur: j,
            onKeydown: f[6] || (f[6] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onKeyDown) && ((S = s(d)) == null ? void 0 : S.onKeyDown(...E));
            }),
            onKeyup: f[7] || (f[7] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onKeyUp) && ((S = s(d)) == null ? void 0 : S.onKeyUp(...E));
            }),
            onCompositionstart: f[8] || (f[8] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onCompositionStart) && ((S = s(d)) == null ? void 0 : S.onCompositionStart(...E));
            }),
            onCompositionend: f[9] || (f[9] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onCompositionEnd) && ((S = s(d)) == null ? void 0 : S.onCompositionEnd(...E));
            }),
            onMouseup: f[10] || (f[10] = (...E) => {
              var M, S;
              return ((M = s(d)) == null ? void 0 : M.onMouseUp) && ((S = s(d)) == null ? void 0 : S.onMouseUp(...E));
            }),
            onClick: ne,
            "aria-placeholder": y.value,
            contenteditable: D.value,
            innerHTML: i.value,
            ref_key: "root",
            ref: n
          }, null, 40, Nt)) : m("", !0),
          P.value ? (l(), C(s(c), {
            key: 2,
            is: "sv-character-counter",
            counter: O.value,
            remainingCharacterCounter: A.value
          }, null, 8, ["counter", "remainingCharacterCounter"])) : m("", !0)
        ])
      ]),
      v.value ? (l(), r("span", Mt, k(v.value), 1)) : m("", !0)
    ], 2));
  }
}), Et = {
  key: 0,
  class: "svc-toolbox__search-container"
}, It = {
  key: 1,
  class: "svc-toolbox__placeholder"
}, Bt = {
  key: 1,
  class: "svc-toolbox__category"
}, Pt = /* @__PURE__ */ g({
  __name: "AdaptiveToolbox",
  props: {
    model: {}
  },
  setup(u) {
    const t = u, e = w(() => t.model.toolbox), o = I();
    T(() => e.value);
    let n;
    B(() => {
      e.value.setRootElement(o.value), n = new Ce(
        e.value.containerElement,
        e.value,
        e.value.itemSelector
      );
    }), K(() => {
      n == null || n.dispose(), e.value.setRootElement(void 0);
    });
    const i = w(() => e.value.renderedActions);
    return (d, v) => (l(), r("div", {
      class: _(e.value.classNames),
      ref_key: "root",
      ref: o
    }, [
      a("div", {
        onFocusout: v[0] || (v[0] = (b) => e.value.focusOut(b)),
        class: "svc-toolbox__panel"
      }, [
        e.value.showSearch ? (l(), r("div", Et, [
          e.value.isCompactRendered ? (l(), C(s(c), {
            is: "svc-toolbox-tool",
            creator: d.model,
            key: "searchitem",
            item: e.value.searchItem,
            parentModel: e.value,
            isCompact: e.value.isCompactRendered
          }, null, 8, ["creator", "item", "parentModel", "isCompact"])) : m("", !0),
          p(s(c), {
            is: "svc-search",
            model: e.value.searchManager
          }, null, 8, ["model"]),
          v[1] || (v[1] = a("div", { class: "svc-toolbox__category-separator svc-toolbox__category-separator--search" }, null, -1))
        ])) : m("", !0),
        e.value.showPlaceholder ? (l(), r("div", It, k(e.value.toolboxNoResultsFound), 1)) : m("", !0),
        p(X, null, {
          default: Y(() => [
            e.value.showInSingleCategory ? m("", !0) : (l(!0), r($, { key: 0 }, R(e.value.categories, (b, y) => (l(), C(s(c), {
              is: "svc-toolbox-category",
              key: y,
              category: b,
              toolbox: e.value
            }, null, 8, ["category", "toolbox"]))), 128)),
            e.value.showInSingleCategory ? (l(), r("div", Bt, [
              (l(!0), r($, null, R(i.value, (b, y) => (l(), C(s(c), {
                key: y,
                is: "svc-toolbox-tool",
                creator: d.model,
                item: b,
                parentModel: e.value,
                isCompact: e.value.isCompactRendered
              }, null, 8, ["creator", "item", "parentModel", "isCompact"]))), 128))
            ])) : m("", !0)
          ]),
          _: 1
        })
      ], 32)
    ], 2));
  }
}), Rt = {
  key: 0,
  class: "svc-toolbox__category-separator"
}, Vt = /* @__PURE__ */ g({
  __name: "ToolboxTool",
  props: {
    creator: {},
    item: {},
    parentModel: {},
    isCompact: { type: Boolean }
  },
  setup(u) {
    const t = u, e = z(
      () => new Te(
        t.item,
        t.creator,
        t.parentModel
      ),
      [() => t.creator, () => t.item],
      (o) => {
        o.dispose();
      }
    );
    return T(() => t.item), (o, n) => {
      var i;
      return l(), r("div", {
        class: _(o.item.css)
      }, [
        o.item.needSeparator && !o.creator.toolbox.showCategoryTitles ? (l(), r("div", Rt)) : m("", !0),
        a("div", {
          class: "svc-toolbox__tool-content sv-action__content",
          onPointerdown: n[0] || (n[0] = (...d) => {
            var v, b;
            return ((v = s(e)) == null ? void 0 : v.onPointerDown) && ((b = s(e)) == null ? void 0 : b.onPointerDown(...d));
          })
        }, [
          p(s(c), {
            viewModel: s(e),
            is: (i = s(e)) == null ? void 0 : i.itemComponent,
            item: o.item,
            creator: o.creator,
            isCompact: o.isCompact
          }, null, 8, ["viewModel", "is", "item", "creator", "isCompact"])
        ], 32)
      ], 2);
    };
  }
}), zt = ["aria-label", "title"], At = { class: "svc-toolbox__item-container" }, Lt = {
  key: 0,
  class: "svc-toolbox__item-title"
}, Ft = /* @__PURE__ */ g({
  __name: "ToolboxItem",
  props: {
    creator: {},
    item: {},
    isCompact: { type: Boolean },
    viewModel: {}
  },
  setup(u) {
    return (t, e) => (l(), r($, null, [
      h((l(), r("div", {
        class: _(["svc-toolbox__item", t.item.renderedCss]),
        role: "button",
        "aria-label": t.item.tooltip,
        title: t.item.tooltip,
        onClick: e[0] || (e[0] = (o) => t.viewModel.click(o))
      }, [
        a("span", At, [
          t.item.iconName ? (l(), C(s(c), {
            key: 0,
            is: "sv-svg-icon",
            iconName: t.item.iconName,
            size: "auto",
            class: "svc-toolbox__item-icon"
          }, null, 8, ["iconName"])) : m("", !0)
        ]),
        t.isCompact ? m("", !0) : (l(), r("span", Lt, k(t.item.title), 1))
      ], 10, zt)), [
        [s(N)]
      ]),
      t.isCompact ? (l(), r("span", {
        key: 0,
        class: "svc-toolbox__item-banner",
        onClick: e[1] || (e[1] = (o) => t.viewModel.click(o))
      }, [
        p(s(c), {
          is: "sv-svg-icon",
          iconName: t.item.iconName,
          size: 24,
          class: "svc-toolbox__item-icon"
        }, null, 8, ["iconName"]),
        a("span", null, k(t.item.title), 1)
      ])) : m("", !0)
    ], 64));
  }
}), Kt = /* @__PURE__ */ g({
  __name: "ToolboxItemGroup",
  props: {
    creator: {},
    item: {},
    isCompact: { type: Boolean },
    viewModel: {}
  },
  setup(u) {
    const t = u, e = (n) => {
      t.viewModel.onMouseOver(t.item, n);
    }, o = (n) => {
      t.viewModel.onMouseLeave(t.item, n);
    };
    return (n, i) => (l(), r($, null, [
      p(s(c), {
        is: "svc-toolbox-item",
        viewModel: n.viewModel,
        item: n.item,
        creator: n.creator,
        isCompact: n.isCompact
      }, null, 8, ["viewModel", "item", "creator", "isCompact"]),
      a("div", {
        class: "svc-toolbox__item-submenu-button",
        onMouseover: e,
        onMouseleave: o
      }, [
        p(s(c), {
          is: "sv-svg-icon",
          iconName: n.item.subitemsButtonIcon,
          size: "auto"
        }, null, 8, ["iconName"]),
        p(s(c), {
          is: "sv-popup",
          model: n.item.popupModel
        }, null, 8, ["model"])
      ], 32)
    ], 64));
  }
}), Ut = { class: "svc-toolbox__category-title" }, Ht = {
  key: 0,
  class: "svc-toolbox__category-header__controls"
}, Ot = { className: "svc-toolbox__category-header-wrapper" }, Qt = /* @__PURE__ */ g({
  __name: "ToolboxCategory",
  props: {
    category: {},
    toolbox: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.category), (e, o) => (l(), r("div", {
      class: _(["svc-toolbox__category", {
        "svc-toolbox__category--collapsed": e.category.collapsed,
        "svc-toolbox__category--empty": e.category.empty
      }])
    }, [
      h((l(), r("div", {
        class: _(["svc-toolbox__category-header", {
          "svc-toolbox__category-header--collapsed": e.toolbox.canCollapseCategories
        }]),
        onClick: o[0] || (o[0] = (n) => e.category.toggleState())
      }, [
        a("span", Ut, k(e.category.title), 1),
        e.toolbox.canCollapseCategories ? (l(), r("div", Ht, [
          a("div", Ot, [
            h(p(s(c), {
              is: "sv-svg-icon",
              iconName: "icon-arrow-down",
              class: "svc-toolbox__category-header__button svc-string-editor__button--expand",
              size: "auto"
            }, null, 512), [
              [L, e.category.collapsed]
            ])
          ]),
          h(p(s(c), {
            is: "sv-svg-icon",
            iconName: "icon-arrow-up",
            class: "svc-toolbox__category-header__button svc-string-editor__button--collapse",
            size: "auto"
          }, null, 512), [
            [L, !e.category.collapsed]
          ])
        ])) : m("", !0)
      ], 2)), [
        [s(N)]
      ]),
      (l(!0), r($, null, R(e.category.items, (n, i) => (l(), C(s(c), {
        is: "svc-toolbox-tool",
        item: n,
        key: i,
        creator: e.toolbox.creator,
        parentModel: e.toolbox,
        isCompact: !1
      }, null, 8, ["item", "creator", "parentModel"]))), 128))
    ], 2));
  }
}), Gt = /* @__PURE__ */ g({
  __name: "ToolboxList",
  props: {
    model: {},
    creator: {}
  },
  setup(u) {
    return (t, e) => (l(), r("div", {
      class: _(t.model.cssClasses.root)
    }, [
      (l(!0), r($, null, R(t.model.renderedActions, (o, n) => (l(), C(s(c), {
        key: n,
        is: "svc-toolbox-tool",
        creator: t.creator,
        item: o,
        parentModel: t.model,
        isCompact: !1
      }, null, 8, ["creator", "item", "parentModel"]))), 128))
    ], 2));
  }
}), Wt = { class: "svc-flex-column" }, jt = { class: "svc-tab-designer_content" }, Jt = {
  key: 0,
  class: "svc-designer-header"
}, Zt = {
  class: "svc-designer__placeholder-container",
  "data-sv-drop-target-survey-element": "newGhostPage"
}, Xt = {
  className: "svc-designer-placeholder-page",
  "data-sv-drop-target-survey-element": "newGhostPage"
}, Yt = {
  key: 0,
  class: "svc-designer-header"
}, xt = ["data-sv-drop-target-survey-element", "data-sv-drop-target-page"], en = ["data-sv-drop-target-survey-element", "data-sv-drop-target-page"], on = {
  key: 0,
  class: "svc-tab-designer__tools"
}, sn = {
  key: 0,
  class: "svc-tab-designer__page-navigator"
}, tn = {
  key: 1,
  class: "svc-tab-designer__toolbar"
}, nn = /* @__PURE__ */ g({
  __name: "Designer",
  props: {
    model: {}
  },
  setup(u) {
    const t = u, e = w(() => t.model.survey);
    return T(() => t.model), T(() => e.value), (o, n) => (l(), r($, null, [
      a("div", Wt, [
        o.model.isToolboxVisible ? (l(), C(s(c), {
          key: 0,
          is: "svc-toolbox",
          model: o.model.creator
        }, null, 8, ["model"])) : m("", !0)
      ]),
      a("div", {
        class: _(["svc-tab-designer", o.model.getRootCss()]),
        onClick: n[0] || (n[0] = (...i) => o.model.clickDesigner && o.model.clickDesigner(...i))
      }, [
        p(X, null, {
          default: Y(() => [
            a("div", jt, [
              o.model.showPlaceholder ? (l(), r($, { key: 0 }, [
                o.model.creator.showHeaderInEmptySurvey && o.model.creator.allowEditSurveyTitle ? (l(), r("div", Jt, [
                  p(s(c), {
                    is: "survey-header",
                    survey: o.model.creator.survey
                  }, null, 8, ["survey"])
                ])) : m("", !0),
                a("div", Zt, [
                  p(W, {
                    name: "designer",
                    placeholderTitleText: o.model.placeholderTitleText,
                    placeholderDescriptionText: o.model.placeholderDescriptionText
                  }, null, 8, ["placeholderTitleText", "placeholderDescriptionText"]),
                  a("div", Xt, [
                    p(s(c), {
                      is: "svc-page",
                      survey: o.model.creator.survey,
                      creator: o.model.creator,
                      page: o.model.newPage,
                      isGhost: !0
                    }, null, 8, ["survey", "creator", "page"])
                  ])
                ])
              ], 64)) : m("", !0),
              o.model.showPlaceholder ? m("", !0) : (l(), r($, { key: 1 }, [
                a("div", {
                  class: _(o.model.designerCss),
                  style: F([
                    { maxWidth: o.model.survey.renderedWidth },
                    o.model.surveyThemeVariables
                  ])
                }, [
                  o.model.creator.allowEditSurveyTitle ? (l(), r("div", Yt, [
                    p(s(c), {
                      is: "survey-header",
                      survey: o.model.creator.survey
                    }, null, 8, ["survey"])
                  ])) : m("", !0),
                  o.model.creator.pageEditMode !== "bypage" ? (l(!0), r($, { key: 1 }, R(o.model.pages, (i) => (l(), r("div", {
                    key: i.id,
                    class: "svc-page",
                    "data-sv-drop-target-survey-element": i != o.model.newPage ? i.name : "newGhostPage",
                    "data-sv-drop-target-page": i.name
                  }, [
                    p(s(c), {
                      is: "svc-page",
                      survey: o.model.creator.survey,
                      creator: o.model.creator,
                      page: i,
                      isGhost: i == o.model.newPage
                    }, null, 8, ["survey", "creator", "page", "isGhost"])
                  ], 8, xt))), 128)) : m("", !0),
                  o.model.pagesController.page2Display && o.model.creator.pageEditMode === "bypage" ? (l(), r("div", {
                    key: 2,
                    class: "svc-page",
                    "data-sv-drop-target-survey-element": o.model.displayPageDropTarget,
                    "data-sv-drop-target-page": o.model.pagesController.page2Display.name
                  }, [
                    p(s(c), {
                      is: "svc-page",
                      page: o.model.pagesController.page2Display,
                      creator: o.model.creator,
                      isGhost: o.model.pagesController.page2Display == o.model.newPage
                    }, null, 8, ["page", "creator", "isGhost"])
                  ], 8, en)) : m("", !0)
                ], 6),
                o.model.showSurfaceTools ? (l(), r("div", on, [
                  o.model.creator.showPageNavigator ? (l(), r("div", sn, [
                    p(s(c), {
                      is: "svc-page-navigator",
                      pagesController: o.model.pagesController,
                      pageEditMode: o.model.creator.pageEditMode
                    }, null, 8, ["pagesController", "pageEditMode"])
                  ])) : m("", !0),
                  o.model.showSurfaceToolbar ? (l(), r("div", tn, [
                    p(s(c), {
                      is: "sv-action-bar",
                      model: o.model.surfaceToolbar
                    }, null, 8, ["model"])
                  ])) : m("", !0)
                ])) : m("", !0)
              ], 64))
            ])
          ]),
          _: 1
        })
      ], 2)
    ], 64));
  }
}), ln = ["id", "data-sv-drop-target-survey-page"], an = { class: "svc-page__content-actions" }, rn = {
  key: 1,
  class: "svc-page__content-actions"
}, dn = {
  key: 2,
  class: "svc-page__placeholder_frame"
}, un = { class: "svc-panel__placeholder_frame" }, cn = { class: "svc-panel__placeholder" }, vn = /* @__PURE__ */ g({
  __name: "Page",
  props: {
    creator: {},
    survey: {},
    page: {},
    isGhost: { type: Boolean }
  },
  setup(u) {
    const t = u, e = I(), o = z(
      () => {
        const i = new De(t.creator, t.page);
        return i.isGhost = t.isGhost, i;
      },
      [() => t.page],
      (i) => {
        i.dispose();
      }
    );
    G(
      () => t.isGhost,
      () => {
        o.value && (o.value.isGhost = t.isGhost);
      }
    ), oe(() => {
      e.value && o.value && (o.value.rootElement = e.value);
    }), B(() => {
      e.value && o.value && (o.value.rootElement = e.value);
    });
    const n = (i) => {
      o.value.hover(i, i.currentTarget);
    };
    return (i, d) => s(o).page ? h((l(), r("div", {
      key: s(o).page.id,
      id: s(o).page.id,
      class: _(["svc-page__content", s(o).css]),
      "data-sv-drop-target-survey-page": s(o).dropTargetName,
      onClick: d[1] || (d[1] = (v) => {
        s(o).select(s(o), v), v.stopPropagation();
      }),
      ref_key: "root",
      ref: e,
      onDblclick: d[2] || (d[2] = (v) => s(o).dblclick(v)),
      onMouseover: n,
      onMouseleave: n
    }, [
      d[3] || (d[3] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--top" }, null, -1)),
      d[4] || (d[4] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--bottom" }, null, -1)),
      s(o).allowDragging && !s(o).isGhost ? (l(), r("div", {
        key: 0,
        class: "svc-question__drag-area",
        onPointerdown: d[0] || (d[0] = (v) => s(o).onPointerDown(v))
      }, [
        p(s(c), V({
          is: "sv-svg-icon",
          class: "svc-question__drag-element"
        }, {
          css: "svc-question__drag-element",
          iconName: "icon-drag-area-indicator_24x16",
          size: "auto"
        }), null, 16),
        a("div", an, [
          p(s(c), {
            is: "sv-action-bar",
            model: s(o).actionContainer
          }, null, 8, ["model"])
        ])
      ], 32)) : m("", !0),
      !s(o).allowDragging || s(o).isGhost ? (l(), r("div", rn, [
        p(s(c), {
          is: "sv-action-bar",
          model: s(o).actionContainer
        }, null, 8, ["model"])
      ])) : m("", !0),
      p(s(c), {
        is: "survey-page",
        survey: s(o).creator.survey,
        page: s(o).page
      }, null, 8, ["survey", "page"]),
      s(o).showPlaceholder ? (l(), r("div", dn, [
        a("div", un, [
          a("div", cn, k(s(o).placeholderText), 1)
        ])
      ])) : m("", !0),
      p(s(c), {
        is: "sv-action-bar",
        model: s(o).footerActionsBar
      }, null, 8, ["model"])
    ], 42, ln)), [
      [s(N)]
    ]) : m("", !0);
  }
}), pn = { class: "svc-add-new-item-button__text" }, mn = /* @__PURE__ */ g({
  __name: "AddQuestion",
  props: {
    item: {},
    buttonClass: {},
    renderPopup: {}
  },
  setup(u) {
    const t = u;
    T(() => t.item.data);
    const e = w(() => "svc-element__add-new-question " + (t.buttonClass || "svc-btn")), o = w(() => t.renderPopup === void 0 || t.renderPopup !== !1);
    return (n, i) => (l(), r($, null, [
      h((l(), r("div", {
        class: _(e.value),
        onClick: i[0] || (i[0] = (d) => {
          n.item.data.addNewQuestion(n.item, d), d.stopPropagation();
        }),
        onMouseover: i[1] || (i[1] = (d) => n.item.data.hoverStopper && n.item.data.hoverStopper(d, d.currentTarget))
      }, [
        p(s(c), {
          is: "sv-svg-icon",
          class: "svc-panel__add-new-question-icon",
          iconName: "icon-add_24x24",
          size: "auto"
        }),
        a("span", pn, k(n.item.data.addNewQuestionText), 1),
        o.value ? (l(), C(s(c), {
          key: 0,
          is: "svc-add-question-type-selector",
          questionTypeSelectorModel: n.item.data.questionTypeSelectorModel,
          renderPopup: o.value
        }, null, 8, ["questionTypeSelectorModel", "renderPopup"])) : m("", !0)
      ], 34)), [
        [s(N)]
      ]),
      o.value ? m("", !0) : (l(), C(s(c), {
        key: 0,
        is: "svc-add-question-type-selector",
        questionTypeSelectorModel: n.item.data.questionTypeSelectorModel,
        renderPopup: o.value
      }, null, 8, ["questionTypeSelectorModel", "renderPopup"]))
    ], 64));
  }
}), _n = ["title", "aria-label"], gn = /* @__PURE__ */ g({
  __name: "AddQuestionTypeSelector",
  props: {
    questionTypeSelectorModel: {},
    renderPopup: {}
  },
  setup(u) {
    const t = u;
    return T(() => t.questionTypeSelectorModel), (e, o) => h((l(), r("button", {
      type: "button",
      onClick: o[0] || (o[0] = (n) => {
        e.questionTypeSelectorModel.action(), n.stopPropagation();
      }),
      title: e.questionTypeSelectorModel.title,
      "aria-label": e.questionTypeSelectorModel.title,
      class: "svc-element__question-type-selector"
    }, [
      p(s(c), V({
        is: "sv-svg-icon",
        class: "svc-element__question-type-selector-icon"
      }, {
        iconName: e.questionTypeSelectorModel.iconName,
        size: "auto",
        title: e.questionTypeSelectorModel.title
      }), null, 16),
      e.renderPopup ? (l(), C(s(c), {
        key: 0,
        is: "sv-popup",
        model: e.questionTypeSelectorModel.popupModel
      }, null, 8, ["model"])) : m("", !0)
    ], 8, _n)), [
      [s(N)]
    ]);
  }
}), bn = /* @__PURE__ */ g({
  __name: "Row",
  props: {
    componentData: {}
  },
  setup(u) {
    const t = u, e = w(() => t.componentData.creator), o = w(() => t.componentData.row), n = z(
      () => new Ne(e.value, o.value, void 0),
      [() => e.value, () => o.value],
      (i) => {
        i.dispose();
      }
    );
    return B(() => {
      n.value && n.value.subscribeElementChanges();
    }), K(() => {
      n.value && n.value.unsubscribeElementChanges();
    }), (i, d) => (l(), r("div", {
      class: _(s(n).cssClasses)
    }, [
      d[0] || (d[0] = a("div", { class: "svc-row__drop-indicator svc-row__drop-indicator--top" }, null, -1)),
      d[1] || (d[1] = a("div", { class: "svc-row__drop-indicator svc-row__drop-indicator--bottom" }, null, -1)),
      Z(i.$slots, "default")
    ], 2));
  }
}), yn = ["data-sv-drop-target-survey-element"], hn = { class: "svc-fake-title" }, qn = { class: "svc-question__top-actions" }, Cn = {
  key: 0,
  class: "svc-panel__placeholder_frame-wrapper"
}, wn = { class: "svc-panel__placeholder_frame" }, kn = {
  class: "svc-panel__placeholder",
  "data-bind": "text: placeholderText"
}, te = /* @__PURE__ */ g({
  __name: "QuestionBase",
  props: {
    createModel: { type: Function },
    element: {},
    adornerComponent: {},
    showPlaceholderComponent: { type: Boolean },
    placeholderComponent: {},
    getPlaceholderComponentData: { type: Function },
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = I(), o = z(
      () => t.createModel(),
      [() => t.componentName, () => t.componentData],
      (d) => {
        d.dispose();
      }
    ), n = w(
      () => o.value.isBannerShowing ? o.value.createBannerParams() : null
    );
    oe(() => {
      e.value && o.value && (o.value.rootElement = e.value);
    }), B(() => {
      e.value && o.value && (o.value.rootElement = e.value);
    });
    const i = (d) => {
      o.value.select(o.value, d), d.stopPropagation();
    };
    return (d, v) => s(o) ? (l(), r("div", {
      key: 0,
      class: _(["svc-question__adorner", s(o).rootCss()]),
      ref_key: "root",
      ref: e,
      onDblclick: v[2] || (v[2] = (b) => s(o).dblclick(b)),
      onMouseover: v[3] || (v[3] = (b) => s(o).hover(b, b.currentTarget)),
      onMouseleave: v[4] || (v[4] = (b) => s(o).hover(b, b.currentTarget)),
      "data-sv-drop-target-survey-element": s(o).element.name || null,
      "data-bind": "css: rootCss(), attr: { 'data-sv-drop-target-survey-element': element.name || null }, event: { mouseover: function(m, e) { hover(e, $element); }, mouseleave: function(m, e) { hover(e, $element); } }"
    }, [
      s(o).showHiddenTitle ? (l(), r("div", {
        key: 0,
        class: _(s(o).cssCollapsedHiddenHeader)
      }, [
        d.element.hasTitle ? (l(), C(s(c), {
          key: 0,
          is: "survey-element-title",
          element: d.element
        }, null, 8, ["element"])) : (l(), r("div", {
          key: 1,
          class: _(s(o).cssCollapsedHiddenTitle)
        }, [
          a("span", hn, k(d.element.name), 1)
        ], 2))
      ], 2)) : m("", !0),
      h((l(), r("div", {
        onClick: v[1] || (v[1] = (b) => {
          s(o).select(s(o), b), b.stopPropagation();
        }),
        class: _(s(o).css())
      }, [
        v[5] || (v[5] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--left" }, null, -1)),
        v[6] || (v[6] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--right" }, null, -1)),
        v[7] || (v[7] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--top" }, null, -1)),
        v[8] || (v[8] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--bottom" }, null, -1)),
        s(o).allowDragging ? (l(), r("div", {
          key: 0,
          class: "svc-question__drag-area",
          onPointerdown: v[0] || (v[0] = (b) => s(o).onPointerDown(b))
        }, [
          p(s(c), V({
            is: "sv-svg-icon",
            class: "svc-question__drag-element"
          }, {
            css: "svc-question__drag-element",
            iconName: "icon-drag-area-indicator_24x16",
            size: "auto"
          }), null, 16),
          a("div", qn, [
            p(s(c), {
              is: "sv-action-bar",
              model: s(o).topActionContainer,
              handleClick: !1
            }, null, 8, ["model"])
          ])
        ], 32)) : m("", !0),
        s(o).needToRenderContent ? (l(), r($, { key: 1 }, [
          p(s(c), {
            is: "sv-template-renderer",
            componentName: d.componentName,
            componentData: d.componentData
          }, null, 8, ["componentName", "componentData"]),
          s(o).isEmptyElement && !d.showPlaceholderComponent ? (l(), r("div", Cn, [
            a("div", wn, [
              a("div", kn, k(s(o).placeholderText), 1)
            ])
          ])) : m("", !0),
          s(o).isEmptyElement && d.showPlaceholderComponent ? (l(), C(s(c), V(
            {
              key: 1,
              is: d.placeholderComponent
            },
            d.getPlaceholderComponentData && d.getPlaceholderComponentData(s(o))
          ), null, 16, ["is"])) : m("", !0),
          d.adornerComponent ? (l(), C(s(c), {
            key: 2,
            is: d.adornerComponent,
            model: s(o),
            element: d.element
          }, null, 8, ["is", "model", "element"])) : m("", !0),
          s(o).isBannerShowing ? (l(), C(s(c), {
            key: 3,
            is: "svc-question-banner",
            model: n.value
          }, null, 8, ["model"])) : m("", !0),
          a("div", {
            class: "svc-question__content-actions",
            onFocusin: i
          }, [
            p(s(c), {
              is: "sv-action-bar",
              model: s(o).actionContainer,
              handleClick: !1
            }, null, 8, ["model"])
          ], 32)
        ], 64)) : m("", !0)
      ], 2)), [
        [s(N), { disableTabStop: !0 }]
      ])
    ], 42, yn)) : m("", !0);
  }
}), ie = /* @__PURE__ */ g({
  __name: "Question",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = () => new se(
      t.componentData.data,
      t.componentData.element,
      null
    );
    return (o, n) => (l(), C(te, {
      createModel: e,
      element: o.componentData.element,
      "component-name": o.componentName,
      "component-data": o.componentData
    }, null, 8, ["element", "component-name", "component-data"]));
  }
}), fn = /* @__PURE__ */ g({
  __name: "QuestionImage",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = () => new Me(
      t.componentData.data,
      t.componentData.element,
      null
    ), o = (n) => ({
      question: n == null ? void 0 : n.filePresentationModel
    });
    return (n, i) => (l(), C(te, {
      "create-model": e,
      element: t.componentData.element,
      "show-placeholder-component": !0,
      "component-data": n.componentData,
      "component-name": n.componentName,
      "placeholder-component": "survey-file",
      "get-placeholder-component-data": o,
      "adorner-component": "svc-image-question-adorner"
    }, null, 8, ["element", "component-data", "component-name"]));
  }
}), $n = {
  key: 0,
  class: "svc-image-question-controls"
}, Tn = ["accept"], Dn = {
  class: "svc-context-button",
  title: void 0,
  "aria-label": void 0
}, Nn = {
  key: 1,
  class: "svc-image-question__loading-placeholder"
}, Mn = { class: "svc-image-question__loading" }, Sn = /* @__PURE__ */ g({
  __name: "Image",
  props: {
    model: {},
    element: {}
  },
  setup(u) {
    return (t, e) => (l(), r($, null, [
      !t.model.isUploading && !t.model.isEmptyElement ? (l(), r("div", $n, [
        t.model.allowEdit ? (l(), r($, { key: 0 }, [
          a("input", {
            type: "file",
            "aria-hidden": "true",
            tabindex: "-1",
            accept: t.model.acceptedTypes,
            class: "svc-choose-file-input"
          }, null, 8, Tn),
          h((l(), r("span", Dn, [
            p(s(c), {
              is: "sv-svg-icon",
              iconName: "icon-choosefile",
              size: "auto",
              onClick: e[0] || (e[0] = (o) => t.model.chooseFile(t.model))
            })
          ])), [
            [s(N)]
          ])
        ], 64)) : m("", !0)
      ])) : m("", !0),
      t.model.isUploading && !t.model.isEmptyElement ? (l(), r("div", Nn, [
        a("div", Mn, [
          p(s(c), { is: "sv-loading-indicator" })
        ])
      ])) : m("", !0)
    ], 64));
  }
}), En = { class: "svc-rating-question-content" }, In = /* @__PURE__ */ g({
  __name: "Rating",
  props: {
    componentData: {},
    componentName: {}
  },
  setup(u) {
    const t = u, e = z(
      () => new Se(
        t.componentData.data,
        t.componentData.question,
        null
      ),
      [() => t.componentData.data, () => t.componentData.question]
    );
    return (o, n) => {
      var i, d, v, b, y, D, O, P, A;
      return l(), r("div", En, [
        a("div", {
          class: _((i = s(e)) == null ? void 0 : i.controlsClassNames)
        }, [
          (d = s(e)) != null && d.allowRemove ? h((l(), C(s(c), {
            key: 0,
            is: "sv-svg-icon",
            iconName: "icon-remove_16x16",
            size: "auto",
            onClick: n[0] || (n[0] = (j) => {
              var U;
              return (U = s(e)) == null ? void 0 : U.removeItem(s(e));
            }),
            class: _((v = s(e)) == null ? void 0 : v.removeClassNames),
            title: (b = s(e)) == null ? void 0 : b.removeTooltip,
            "aria-label": (y = s(e)) == null ? void 0 : y.removeTooltip
          }, null, 8, ["class", "title", "aria-label"])), [
            [s(N)]
          ]) : m("", !0),
          (D = s(e)) != null && D.allowAdd ? h((l(), C(s(c), {
            key: 1,
            is: "sv-svg-icon",
            iconName: "icon-add_16x16",
            size: "auto",
            onClick: n[1] || (n[1] = (j) => {
              var U;
              return (U = s(e)) == null ? void 0 : U.addItem(s(e));
            }),
            class: _((O = s(e)) == null ? void 0 : O.addClassNames),
            title: (P = s(e)) == null ? void 0 : P.addTooltip,
            "aria-label": (A = s(e)) == null ? void 0 : A.addTooltip
          }, null, 8, ["class", "title", "aria-label"])), [
            [s(N)]
          ]) : m("", !0)
        ], 2),
        Z(o.$slots, "default")
      ]);
    };
  }
}), Bn = {
  key: 0,
  class: "svc-matrix-cell__question-controls"
}, Pn = /* @__PURE__ */ g({
  __name: "MatrixCell",
  props: {
    componentData: {}
  },
  setup(u) {
    const t = u, e = w(() => t.componentData.creator), o = w(() => t.componentData.row), n = w(() => t.componentData.column), i = w(() => t.componentData.element), d = w(
      () => t.componentData.question
    ), v = z(
      () => {
        var b;
        return t.componentData ? new Ee(
          e.value,
          i.value,
          d.value,
          o.value,
          n.value || ((b = i.value.cell) == null ? void 0 : b.column)
        ) : void 0;
      },
      [
        () => e.value,
        () => o.value,
        () => n.value,
        () => d.value
      ]
    );
    return (b, y) => {
      var D, O;
      return l(), r("div", {
        tabindex: "-1",
        class: "svc-matrix-cell",
        onClick: y[1] || (y[1] = (P) => {
          var A;
          return (A = s(v)) == null ? void 0 : A.selectContext(s(v), P);
        }),
        onMouseover: y[2] || (y[2] = (P) => {
          var A;
          return (A = s(v)) == null ? void 0 : A.hover(P, P.currentTarget);
        }),
        onMouseleave: y[3] || (y[3] = (P) => {
          var A;
          return (A = s(v)) == null ? void 0 : A.hover(P, P.currentTarget);
        })
      }, [
        a("div", {
          class: _(["svc-matrix-cell--selected", { "svc-visible": (D = s(v)) == null ? void 0 : D.isSelected }])
        }, null, 2),
        Z(b.$slots, "default"),
        (O = s(v)) != null && O.isSupportCellEditor ? (l(), r("div", Bn, [
          h((l(), r("span", {
            class: "svc-matrix-cell__question-controls-button svc-context-button",
            onClick: y[0] || (y[0] = (P) => s(v).editQuestion(s(v), P))
          }, [
            p(s(c), {
              is: "sv-svg-icon",
              iconName: "icon-edit",
              size: "auto"
            })
          ])), [
            [s(N)]
          ])
        ])) : m("", !0)
      ], 32);
    };
  }
}), Rn = { class: "svc-question__adorner" }, Vn = { class: "svc-question__content svc-question__content--in-popup" }, zn = /* @__PURE__ */ g({
  __name: "CellQuestion",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = w(
      () => t.componentData.element
    );
    return T(() => e.value), (o, n) => (l(), r("div", Rn, [
      a("div", Vn, [
        p(s(c), V({ is: o.componentName }, o.componentData), null, 16, ["is"])
      ])
    ]));
  }
}), An = ["data-sv-drop-target-survey-element"], Ln = { class: "svc-fake-title" }, Fn = { class: "svc-question__top-actions" }, Kn = {
  key: 0,
  class: "svc-panel__placeholder_frame-wrapper"
}, Un = { class: "svc-panel__placeholder_frame" }, Hn = { class: "svc-panel__placeholder" }, On = { class: "svc-add-new-item-button__text" }, Qn = {
  key: 1,
  class: "svc-panel__add-new-question-container"
}, Gn = { class: "svc-panel__question-type-selector-popup" }, Wn = { class: "svc-panel__add-new-question-wrapper" }, jn = /* @__PURE__ */ g({
  __name: "Panel",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = z(
      () => new se(
        t.componentData.data,
        t.componentData.element,
        null
      ),
      [() => t.componentData.data, () => t.componentData.element],
      (n) => {
        n.dispose();
      }
    ), o = (n) => {
      n.stopPropagation(), e.value.addNewQuestion();
    };
    return (n, i) => s(e) && !s(e).isDisposed ? (l(), r("div", {
      key: 0,
      class: _(["svc-question__adorner", s(e).rootCss()]),
      onDblclick: i[3] || (i[3] = (d) => s(e).dblclick(d)),
      onMouseover: i[4] || (i[4] = (d) => s(e).hover(d, d.currentTarget)),
      onMouseleave: i[5] || (i[5] = (d) => s(e).hover(d, d.currentTarget)),
      "data-sv-drop-target-survey-element": s(e).element.name || null,
      ref: "root"
    }, [
      s(e).showHiddenTitle ? (l(), r("div", {
        key: 0,
        class: _(s(e).cssCollapsedHiddenHeader)
      }, [
        s(e).element.hasTitle ? (l(), C(s(c), {
          key: 0,
          is: "survey-element-title",
          element: s(e).element
        }, null, 8, ["element"])) : (l(), r("div", {
          key: 1,
          class: _(s(e).cssCollapsedHiddenTitle)
        }, [
          a("span", Ln, k(s(e).element.name), 1)
        ], 2))
      ], 2)) : m("", !0),
      h((l(), r("div", {
        class: _(s(e).css()),
        onClick: i[2] || (i[2] = (d) => s(e).element.isInteractiveDesignElement ? s(e).select(s(e), d) : null)
      }, [
        i[6] || (i[6] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--left" }, null, -1)),
        i[7] || (i[7] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--right" }, null, -1)),
        i[8] || (i[8] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--top" }, null, -1)),
        i[9] || (i[9] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--bottom" }, null, -1)),
        s(e).allowDragging && s(e).element.isInteractiveDesignElement ? (l(), r("div", {
          key: 0,
          class: "svc-question__drag-area",
          onPointerdown: i[0] || (i[0] = (d) => s(e).onPointerDown(d))
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            class: "svc-question__drag-element",
            iconName: "icon-drag-area-indicator_24x16",
            size: "auto"
          }),
          a("div", Fn, [
            p(s(c), {
              is: "sv-action-bar",
              model: s(e).topActionContainer,
              handleClick: !1
            }, null, 8, ["model"])
          ])
        ], 32)) : m("", !0),
        s(e).needToRenderContent ? (l(), r($, { key: 1 }, [
          p(s(c), V({ is: n.componentName }, n.componentData), null, 16, ["is"]),
          s(e).isEmptyElement ? (l(), r("div", Kn, [
            a("div", Un, [
              a("div", Hn, k(s(e).placeholderText), 1),
              s(e).showAddQuestionButton ? h((l(), r("div", {
                key: 0,
                class: "svc-panel__add-new-question svc-action-button",
                onClick: o
              }, [
                p(s(c), {
                  is: "sv-svg-icon",
                  class: "svc-panel__add-new-question-icon",
                  iconName: "icon-add_24x24",
                  size: "auto"
                }),
                a("span", On, k(s(e).addNewQuestionText), 1)
              ])), [
                [s(N)]
              ]) : m("", !0)
            ])
          ])) : m("", !0),
          !s(e).isEmptyElement && s(e).showAddQuestionButton ? (l(), r("div", Qn, [
            a("div", Gn, [
              p(s(c), {
                is: "sv-popup",
                model: s(e).questionTypeSelectorModel.popupModel
              }, null, 8, ["model"])
            ]),
            a("div", Wn, [
              p(s(c), {
                is: "svc-add-new-question-btn",
                item: { data: s(e) },
                buttonClass: "svc-action-button",
                renderPopup: !1
              }, null, 8, ["item"])
            ])
          ])) : m("", !0),
          s(e).element.isInteractiveDesignElement ? (l(), r("div", {
            key: 2,
            class: "svc-question__content-actions",
            onFocusin: i[1] || (i[1] = (d) => s(e).select(s(e), d))
          }, [
            p(s(c), {
              is: "sv-action-bar",
              model: s(e).actionContainer,
              handleClick: !1
            }, null, 8, ["model"])
          ], 32)) : m("", !0)
        ], 64)) : m("", !0)
      ], 2)), [
        [s(N), { disableTabStop: !0 }]
      ])
    ], 42, An)) : m("", !0);
  }
}), Jn = ["data-sv-drop-target-item-value"], Zn = { class: "svc-item-value-controls" }, Xn = {
  key: 0,
  class: "svc-item-value-controls__button svc-item-value-controls__drag"
}, Yn = /* @__PURE__ */ g({
  __name: "ItemValue",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = I(), e = u, o = w(() => e.componentData.data.creator), n = w(() => e.componentData.question), i = w(() => e.componentData.item), d = G(
      () => i.value,
      (b, y) => {
        b && t.value && b.setRootElement(t.value), y && y.setRootElement(void 0);
      }
    );
    B(() => {
      t.value && i.value && i.value.setRootElement(t.value);
    }), K(() => {
      i.value.setRootElement(void 0);
    });
    const v = z(
      () => new Ie(o.value, n.value, i.value),
      [() => o.value, () => n.value, () => i.value],
      (b) => {
        b.dispose();
      }
    );
    return ee(() => {
      d();
    }), (b, y) => (l(), r("div", {
      class: _(["svc-item-value-wrapper", {
        "svc-item-value--new": s(v).isNew,
        "svc-item-value--dragging": s(v).isDragging,
        "svc-item-value--ghost": s(v).isDragDropGhost,
        "svc-item-value--movedown": s(v).isDragDropMoveDown,
        "svc-item-value--moveup": s(v).isDragDropMoveUp
      }]),
      onPointerdown: y[4] || (y[4] = (D) => s(v).onPointerDown(D)),
      "data-sv-drop-target-item-value": s(v).isDraggable ? i.value.value : null,
      ref_key: "root",
      ref: t
    }, [
      y[5] || (y[5] = a("div", { class: "svc-item-value__ghost" }, null, -1)),
      a("div", Zn, [
        s(v).isDraggable ? (l(), r("span", Xn, [
          p(s(c), {
            is: "sv-svg-icon",
            class: "svc-item-value-controls__drag-icon",
            iconName: "icon-drag-24x24",
            size: "auto",
            title: s(v).dragTooltip
          }, null, 8, ["title"])
        ])) : m("", !0),
        s(v).allowAdd ? h((l(), r("span", {
          key: 1,
          class: "svc-item-value-controls__button svc-item-value-controls__add",
          onClick: y[0] || (y[0] = (D) => s(v).add(s(v))),
          "aria-label": void 0
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: "icon-add_16x16",
            size: "auto",
            title: void 0
          })
        ])), [
          [s(N)]
        ]) : m("", !0),
        s(v).allowRemove ? h((l(), r("span", {
          key: 2,
          class: "svc-item-value-controls__button svc-item-value-controls__remove",
          onClick: y[1] || (y[1] = (D) => s(v).remove(s(v))),
          onBlur: y[2] || (y[2] = (D) => s(v).onFocusOut(D)),
          "aria-label": void 0
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            iconName: "icon-remove_16x16",
            size: "auto",
            title: void 0
          })
        ], 32)), [
          [s(N)]
        ]) : m("", !0)
      ]),
      a("div", {
        class: "svc-item-value__item",
        onClick: y[3] || (y[3] = (D) => s(v).select(s(v), D))
      }, [
        p(s(c), V({ is: b.componentName }, b.componentData), null, 16, ["is"])
      ])
    ], 42, Jn));
  }
}), xn = ["data-sv-drop-target-item-value"], el = { class: "svc-image-item-value-wrapper__content" }, ol = ["accept"], sl = {
  key: 0,
  class: "svc-image-item-value__item"
}, tl = {
  key: 2,
  class: "svc-context-container svc-image-item-value-controls"
}, nl = { class: "sd-imagepicker__item sd-imagepicker__item--inline" }, ll = { class: "sd-imagepicker__label" }, il = {
  key: 0,
  class: "svc-image-item-value__loading"
}, al = /* @__PURE__ */ g({
  __name: "ImageItemValue",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = w(() => t.componentData.data.creator), o = w(() => t.componentData.question), n = w(() => t.componentData.item), i = I(), d = z(
      () => {
        const b = new Be(
          e.value,
          o.value,
          n.value,
          null,
          null
        );
        return i != null && i.value && (b.itemsRoot = i.value), b;
      },
      [() => e.value, () => o.value, () => n.value],
      (b) => {
        b.dispose();
      }
    ), v = w(() => {
      const b = !d.value.getIsNewItemSingle();
      return {
        width: b ? o.value.renderedImageWidth + "px" : void 0,
        height: b ? o.value.renderedImageHeight + "px" : void 0
      };
    });
    return B(() => {
      i.value && (d.value.itemsRoot = i.value);
    }), (b, y) => (l(), r("div", {
      onPointerdown: y[8] || (y[8] = (D) => s(d).onPointerDown(D)),
      class: _(s(d).getRootCss()),
      "data-sv-drop-target-item-value": s(d).isDraggable ? n.value.value : null,
      ref_key: "root",
      ref: i
    }, [
      a("div", {
        class: "svc-image-item-value-wrapper__ghost",
        style: F(v.value)
      }, null, 4),
      a("div", el, [
        a("input", {
          type: "file",
          "aria-hidden": "true",
          tabindex: "-1",
          accept: s(d).acceptedTypes,
          class: "svc-choose-file-input"
        }, null, 8, ol),
        !s(d).isNew && !s(d).isUploading ? (l(), r($, { key: 0 }, [
          s(d).isNew ? m("", !0) : (l(), r("div", sl, [
            p(s(c), V({ is: b.componentName }, b.componentData), null, 16, ["is"])
          ])),
          s(d).isDraggable && s(d).canRenderControls ? (l(), r("span", {
            key: 1,
            class: "svc-context-button svc-image-item-value-controls__drag-area-indicator",
            onPointerdown: y[0] || (y[0] = (D) => s(d).onPointerDown(D)),
            title: void 0,
            "aria-label": void 0
          }, [
            p(s(c), {
              is: "sv-svg-icon",
              iconName: "icon-drag-24x24",
              size: "auto"
            })
          ], 32)) : m("", !0),
          s(d).canRenderControls ? (l(), r("div", tl, [
            h((l(), r("span", {
              class: "svc-context-button",
              onClick: y[1] || (y[1] = (D) => s(d).chooseFile(s(d))),
              title: void 0,
              "aria-label": void 0
            }, [
              p(s(c), {
                is: "sv-svg-icon",
                role: "button",
                iconName: "icon-choosefile",
                size: "auto",
                title: s(d).selectFileTitle
              }, null, 8, ["title"])
            ])), [
              [s(N)]
            ]),
            h((l(), r("span", {
              class: "svc-context-button svc-context-button--danger",
              onClick: y[2] || (y[2] = (D) => s(d).remove(s(d))),
              title: void 0,
              "aria-label": void 0
            }, [
              p(s(c), {
                is: "sv-svg-icon",
                role: "button",
                iconName: "icon-delete",
                size: "auto",
                title: s(d).removeFileTitle
              }, null, 8, ["title"])
            ])), [
              [s(N)]
            ])
          ])) : m("", !0)
        ], 64)) : m("", !0),
        s(d).isNew || s(d).isUploading ? (l(), r($, { key: 1 }, [
          a("div", {
            class: "svc-image-item-value__item",
            onDragover: y[3] || (y[3] = (D) => s(d).onDragOver(D)),
            onDragleave: y[4] || (y[4] = (D) => s(d).onDragLeave(D)),
            onDrop: y[5] || (y[5] = (D) => s(d).onDrop(D))
          }, [
            a("div", nl, [
              a("label", ll, [
                a("div", {
                  style: F(v.value),
                  class: "sd-imagepicker__image"
                }, [
                  s(d).isUploading ? (l(), r("div", il, [
                    p(s(c), { is: "sv-loading-indicator" })
                  ])) : m("", !0)
                ], 4)
              ])
            ])
          ], 32),
          a("div", {
            class: "svc-image-item-value-controls",
            onPointerdown: y[7] || (y[7] = (D) => D.stopPropagation())
          }, [
            s(d).allowAdd && !s(d).isUploading ? h((l(), r("span", {
              key: 0,
              class: "svc-context-button svc-image-item-value-controls__add",
              onClick: y[6] || (y[6] = (D) => s(d).chooseNewFile(s(d))),
              title: void 0,
              "aria-label": void 0
            }, [
              p(s(c), {
                is: "sv-svg-icon",
                iconName: "icon-add-lg",
                size: "auto",
                title: s(d).addFileTitle
              }, null, 8, ["title"])
            ])), [
              [s(N)]
            ]) : m("", !0)
          ], 32)
        ], 64)) : m("", !0)
      ])
    ], 42, xn));
  }
}), rl = /* @__PURE__ */ g({
  __name: "QuestionEditor",
  props: {
    survey: {}
  },
  setup(u) {
    const t = u, e = w(() => {
      var i;
      return (i = t.survey) == null ? void 0 : i.getAllQuestions()[0];
    }), o = w(() => {
      const i = t.survey;
      if (i && e.value) {
        const d = i.getElementWrapperComponentName(e.value);
        if (d)
          return d;
      }
      return "survey-question";
    }), n = w(() => {
      const i = t.survey;
      let d;
      return i && e.value && (d = i.getElementWrapperComponentData(e.value)), {
        componentName: "survey-question",
        componentData: {
          element: e.value,
          data: d
        }
      };
    });
    return (i, d) => (l(), C(s(c), V({ is: o.value }, n.value), null, 16, ["is"]));
  }
}), dl = ["accept"], ul = { class: "svc-context-container svc-logo-image-controls" }, cl = {
  key: 2,
  class: "svc-logo-image__loading"
}, vl = /* @__PURE__ */ g({
  __name: "Logo",
  props: {
    data: {}
  },
  setup(u) {
    const t = u, e = w(() => t.data), o = w(() => e.value.survey), n = I(), i = z(
      () => new Pe(e.value, null),
      [() => e.value]
    ), d = I(), v = () => {
      d.value = o.value.locLogo.renderedHtml;
    };
    return G(
      () => o.value.locLogo,
      (b, y) => {
        v(), b && b.onStringChanged.add(v), y && b.onStringChanged.remove(v);
      },
      {
        immediate: !0
      }
    ), B(() => {
      n.value && (i.value.root = n.value);
    }), K(() => {
      i.value && (i.value.root = void 0);
    }), (b, y) => (l(), r("div", {
      class: "svc-logo-image",
      ref_key: "root",
      ref: n
    }, [
      a("input", {
        type: "file",
        "aria-hidden": "true",
        tabindex: "-1",
        accept: s(i).acceptedTypes,
        class: "svc-choose-file-input"
      }, null, 8, dl),
      d.value ? m("", !0) : (l(), r($, { key: 0 }, [
        s(i).allowEdit && !s(i).isUploading ? h((l(), r("div", {
          key: 0,
          class: "svc-logo-image-placeholder",
          onClick: y[0] || (y[0] = (D) => s(i).chooseFile(s(i)))
        }, y[3] || (y[3] = [
          a("svg", null, [
            a("use", { "xlink:href": "#icon-image-48x48" })
          ], -1)
        ]))), [
          [s(N)]
        ]) : m("", !0)
      ], 64)),
      d.value && !s(i).isUploading ? (l(), r("div", {
        key: 1,
        class: _(s(i).containerCss)
      }, [
        a("div", ul, [
          h((l(), r("span", {
            class: "svc-context-button",
            onClick: y[1] || (y[1] = (D) => s(i).chooseFile(s(i))),
            title: void 0,
            "aria-label": void 0
          }, [
            p(s(c), {
              is: "sv-svg-icon",
              iconName: "icon-choosefile",
              size: "auto"
            })
          ])), [
            [s(N)]
          ]),
          h((l(), r("span", {
            class: "svc-context-button svc-context-button--danger",
            onClick: y[2] || (y[2] = (D) => s(i).remove(s(i))),
            title: void 0,
            "aria-label": void 0
          }, [
            p(s(c), {
              is: "sv-svg-icon",
              iconName: "icon-clear",
              size: "auto"
            })
          ])), [
            [s(N)]
          ])
        ]),
        p(s(c), {
          is: "sv-logo-image",
          data: o.value
        }, null, 8, ["data"])
      ], 2)) : m("", !0),
      s(i).isUploading ? (l(), r("div", cl, [
        p(s(c), { is: "sv-loading-indicator" })
      ])) : m("", !0)
    ], 512));
  }
}), pl = {
  key: 0,
  class: "svc-search"
}, ml = { class: "svc-search__search-icon" }, _l = ["aria-label", "placeholder"], gl = { class: "svc-search__toolbar" }, bl = { class: "svc-search__toolbar-counter" }, yl = /* @__PURE__ */ g({
  __name: "Search",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    T(() => t.model);
    const e = w({
      get: () => t.model.filterString,
      set: (o) => {
        const n = t.model;
        n.filterString = o;
      }
    });
    return (o, n) => o.model.isVisible ? (l(), r("div", pl, [
      a("div", ml, [
        p(s(c), {
          is: "sv-svg-icon",
          iconName: "icon-search",
          size: "auto"
        })
      ]),
      h(a("input", {
        type: "text",
        class: "svc-search__input",
        "onUpdate:modelValue": n[0] || (n[0] = (i) => e.value = i),
        "aria-label": o.model.filterStringPlaceholder,
        placeholder: o.model.filterStringPlaceholder
      }, null, 8, _l), [
        [de, e.value]
      ]),
      a("div", gl, [
        a("div", bl, k(o.model.matchCounterText), 1),
        p(s(c), {
          is: "sv-action-bar",
          model: o.model.searchActionBar
        }, null, 8, ["model"])
      ])
    ])) : m("", !0);
  }
}), hl = ["title"], ql = /* @__PURE__ */ g({
  __name: "PageNavigator",
  props: {
    pagesController: {},
    pageEditMode: {}
  },
  setup(u) {
    const t = u, e = z(
      () => new Re(t.pagesController, t.pageEditMode),
      [() => t.pagesController, () => t.pageEditMode]
    ), o = I();
    return B(() => {
      if (t.pageEditMode !== "bypage") {
        const n = o.value;
        e.value.attachToUI(n);
      }
    }), ee(() => {
      o.value;
      const n = e.value;
      n.stopItemsContainerHeightObserver(), n.setScrollableContainer(void 0);
    }), K(() => {
      e.value.dispose();
    }), (n, i) => h((l(), r("div", {
      class: "svc-page-navigator",
      ref_key: "root",
      ref: o
    }, [
      h((l(), r("div", {
        class: _(["svc-page-navigator__selector svc-page-navigator__button", { "svc-page-navigator__button--pressed": s(e).isPopupOpened }]),
        onClick: i[0] || (i[0] = (d) => s(e).togglePageSelector(d)),
        title: s(e).pageSelectorCaption
      }, [
        p(s(c), {
          is: "sv-svg-icon",
          class: "svc-page-navigator__button-icon",
          iconName: s(e).icon,
          size: "auto"
        }, null, 8, ["iconName"]),
        p(s(c), {
          is: "sv-popup",
          model: s(e).popupModel
        }, null, 8, ["model"])
      ], 10, hl)), [
        [s(N)]
      ]),
      a("div", null, [
        (l(!0), r($, null, R(s(e).visibleItems, (d) => (l(), C(s(c), {
          is: "svc-page-navigator-item",
          key: d.id,
          model: d
        }, null, 8, ["model"]))), 128))
      ])
    ], 512)), [
      [L, s(e).visible]
    ]);
  }
}), Cl = { class: "svc-page-navigator-item" }, wl = ["title"], kl = { class: "svc-page-navigator-item__banner" }, fl = { class: "svc-page-navigator-item__text" }, $l = /* @__PURE__ */ g({
  __name: "PageNavigatorItem",
  props: {
    model: {}
  },
  setup(u) {
    const t = u;
    T(() => t.model);
    const e = (o) => {
      t.model.action(), o.stopPropagation(), o.preventDefault();
    };
    return (o, n) => (l(), r("div", Cl, [
      h((l(), r("div", {
        class: _(["svc-page-navigator-item-content", {
          "svc-page-navigator-item--selected": o.model.active,
          "svc-page-navigator-item--disabled": o.model.disabled
        }]),
        onClick: n[0] || (n[0] = (i) => e(i))
      }, [
        a("div", {
          class: "svc-page-navigator-item__dot",
          title: o.model.title
        }, n[1] || (n[1] = [
          a("div", { class: "svc-page-navigator-item__dot-content" }, null, -1)
        ]), 8, wl),
        a("div", kl, [
          a("span", fl, k(o.model.title), 1),
          n[2] || (n[2] = a("span", { class: "svc-page-navigator-item__dot" }, [
            a("span", { class: "svc-page-navigator-item__dot-content" })
          ], -1))
        ])
      ], 2)), [
        [s(N)]
      ])
    ]));
  }
}), Tl = { class: "svc-question__dropdown-choices--wrapper" }, Dl = { class: "svc-question__dropdown-choices" }, Nl = /* @__PURE__ */ g({
  __name: "Dropdown",
  props: {
    model: {},
    element: {}
  },
  setup(u) {
    const t = u, e = (n) => t.element.getItemValueWrapperComponentName(n) || t.model.itemComponent, o = (n) => ({
      componentName: t.model.itemComponent,
      componentData: {
        question: t.element,
        item: n,
        data: t.element.getItemValueWrapperComponentData(n)
      }
    });
    return (n, i) => (l(), r("div", Tl, [
      a("div", null, [
        a("div", Dl, [
          (l(!0), r($, null, R(n.model.getRenderedItems(), (d) => (l(), r("div", {
            key: d.value,
            class: _(n.model.getChoiceCss())
          }, [
            p(s(c), V({
              is: e(d),
              ref_for: !0
            }, o(d)), null, 16, ["is"])
          ], 2))), 128))
        ]),
        n.model.needToCollapse ? (l(), C(s(c), {
          key: 0,
          is: "svc-action-button",
          text: n.model.getButtonText(),
          click: n.model.switchCollapse.bind(n.model),
          allowBubble: !0
        }, null, 8, ["text", "click"])) : m("", !0)
      ])
    ]));
  }
}), Ml = /* @__PURE__ */ g({
  __name: "QuestionDropdown",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = () => new Ve(
      t.componentData.data,
      t.componentData.element,
      null
    );
    return (o, n) => (l(), C(te, {
      "create-model": e,
      element: o.componentData.element,
      "component-name": o.componentName,
      "component-data": o.componentData,
      "adorner-component": "svc-dropdown-question-adorner"
    }, null, 8, ["element", "component-name", "component-data"]));
  }
}), Sl = { class: "svc-question__adorner" }, El = { class: "svc-question__content svc-question__content--in-popup" }, Il = { class: "svc-question__dropdown-choices" }, ae = "survey-radiogroup-item", Bl = /* @__PURE__ */ g({
  __name: "CellQuestionDropdown",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = w(
      () => t.componentData.element
    ), o = (i) => e.value.getItemValueWrapperComponentName(i) || ae, n = (i) => ({
      componentName: ae,
      componentData: {
        question: e.value,
        item: i,
        data: e.value.getItemValueWrapperComponentData(i)
      }
    });
    return T(() => e.value), (i, d) => (l(), r("div", Sl, [
      a("div", El, [
        p(s(c), V({ is: i.componentName }, i.componentData), null, 16, ["is"]),
        a("div", Il, [
          (l(!0), r($, null, R(e.value.visibleChoices, (v) => (l(), r("div", {
            key: v.value,
            class: "svc-question__dropdown-choice"
          }, [
            p(s(c), V({
              is: o(v),
              ref_for: !0
            }, n(v)), null, 16, ["is"])
          ]))), 128))
        ])
      ])
    ]));
  }
}), Pl = ["data-sv-drop-target-survey-element"], Rl = { class: "svc-widget__content" }, Vl = {
  key: 1,
  class: "svc-panel__placeholder_frame"
}, zl = { class: "svc-question__content-actions" }, Al = {
  key: 0,
  class: "svc-panel__placeholder_frame"
}, Ll = { class: "svc-panel__placeholder" }, Fl = /* @__PURE__ */ g({
  __name: "CustomWidget",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const t = u, e = I(), o = z(
      () => new se(
        t.componentData.data,
        t.componentData.element,
        null
      ),
      [() => t.componentData.data, () => t.componentData.element],
      (n) => {
        n.dispose();
      }
    );
    return oe(() => {
      e.value && o.value && (o.value.rootElement = e.value);
    }), B(() => {
      e.value && o.value && (o.value.rootElement = e.value);
    }), (n, i) => s(o) ? (l(), r("div", {
      key: 0,
      class: _(["svc-question__adorner", s(o).rootCss()]),
      onMouseover: i[2] || (i[2] = (d) => s(o).hover(d, d.currentTarget)),
      onMouseleave: i[3] || (i[3] = (d) => s(o).hover(d, d.currentTarget)),
      "data-sv-drop-target-survey-element": s(o).element.name || null,
      ref_key: "root",
      ref: e
    }, [
      s(o).element.isInteractiveDesignElement ? h((l(), r("div", {
        key: 0,
        class: _(["svc-question__content", s(o).css()]),
        onClick: i[1] || (i[1] = (d) => s(o).select(s(o), d)),
        "data-bind": "clickBubble: false"
      }, [
        i[5] || (i[5] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--left" }, null, -1)),
        i[6] || (i[6] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--right" }, null, -1)),
        i[7] || (i[7] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--top" }, null, -1)),
        i[8] || (i[8] = a("div", { class: "svc-question__drop-indicator svc-question__drop-indicator--bottom" }, null, -1)),
        s(o).allowDragging ? (l(), r("div", {
          key: 0,
          class: "svc-question__drag-area",
          onPointerdown: i[0] || (i[0] = (d) => s(o).onPointerDown(d))
        }, [
          p(s(c), {
            is: "sv-svg-icon",
            class: "svc-question__drag-element",
            iconName: "icon-drag-area-indicator_24x16",
            size: "auto"
          })
        ], 32)) : m("", !0),
        a("div", Rl, [
          p(s(c), V({ is: n.componentName }, n.componentData), null, 16, ["is"])
        ]),
        s(o).isEmptyElement ? (l(), r("div", Vl, i[4] || (i[4] = [
          a("div", {
            class: "svc-panel__placeholder",
            "data-bind": "text: placeholderText"
          }, null, -1)
        ]))) : m("", !0),
        a("div", zl, [
          p(s(c), {
            is: "sv-action-bar",
            model: s(o).actionContainer,
            handleClick: !1
          }, null, 8, ["model"])
        ])
      ], 2)), [
        [s(N)]
      ]) : m("", !0),
      s(o).element.isInteractiveDesignElement ? m("", !0) : (l(), r($, { key: 1 }, [
        p(s(c), V({ is: n.componentName }, n.componentData), null, 16, ["is"]),
        s(o).isEmptyElement ? (l(), r("div", Al, [
          a("div", Ll, k(s(o).placeholderText), 1)
        ])) : m("", !0)
      ], 64))
    ], 42, Pl)) : m("", !0);
  }
}), Kl = { class: "svc-carry-forward-panel-wrapper" }, Ul = { class: "svc-carry-forward-panel" }, Hl = { class: "svc-carry-forward-panel__link" }, Ol = /* @__PURE__ */ g({
  __name: "QuestionBanner",
  props: {
    model: {}
  },
  setup(u) {
    return (t, e) => (l(), r("div", Kl, [
      a("div", Ul, [
        a("span", null, k(t.model.text) + k(" "), 1),
        a("span", Hl, [
          p(s(c), {
            is: "svc-action-button",
            text: t.model.actionText,
            click: t.model.onClick.bind(t.model)
          }, null, 8, ["text", "click"])
        ])
      ])
    ]));
  }
});
function Ql(u, t, e) {
  u(t, e);
}
function ve(u) {
  const t = Ql.bind(
    void 0,
    u
  );
  t("svc-tabbed-menu", Je), t("svc-tabbed-menu-item-wrapper", Xe), t("svc-tabbed-menu-item", Ye), t("svc-side-bar", so), t("svc-side-bar-default-header", io), t("svc-side-bar-page", ao), t("svc-tabs", vo), t("svc-tab-control", yo), t("svc-tab-button", ko), t("svc-property-grid-placeholder", No), t("svc-side-bar-header", Po), t("svc-side-bar-property-grid-header", Ko), t("svc-property-grid", co), t("svc-object-selector", ro), t("svc-search", yl), t("svc-scroll", X), t("svc-switcher", Xo), t("svc-action-button", Wo), t("svc-question-error", Uo), t("survey-embeddedsurvey", Os), t("sv-logic-operator", Hs), t("survey-linkvalue", Qs), t("survey-color", dt), t("color-item", ut), t("sv-boolean-switch", ft), t("survey-fileedit", _t), t("survey-spinedit", ht), t("survey-textwithreset", le), t("survey-commentwithreset", le), t("survey-widget", Q), t("survey-simulator", es), t("svc-tab-test", as), t("svc-complete-page", ds), t("survey-results", qs), t("survey-results-table-row", ws), t("json-error-item", Rs), t("svc-tab-json-editor-textarea", Es), t("svc-tab-json-editor-ace", Ts), t("svc-tab-translation", Zs), t("sd-translation-line-skeleton", ot), t("svc-translate-from-action", st), t("svc-tab-logic", Fs), t("svc-tab-theme", it), t("svc-toolbox", Pt), t("svc-toolbox-list", Gt), t("svc-toolbox-category", Qt), t("svc-toolbox-tool", Vt), t("svc-toolbox-item", Ft), t("svc-toolbox-item-group", Kt), t(ze, St), t("svc-tab-designer", nn), t("svc-page-navigator", ql), t("svc-page-navigator-item", $l), t("svc-page", vn), t("svc-row", bn), t("svc-add-new-question-btn", mn), t("svc-add-question-type-selector", gn), t("svc-question", ie), t("svc-rating-question", ie), t("svc-rating-question-content", In), t("svc-image-question", fn), t("svc-image-question-adorner", Sn), t("svc-matrix-cell", Pn), t("svc-cell-question", zn), t("svc-cell-dropdown-question", Bl), t("svc-question-editor-content", rl), t("svc-logo-image", vl), t("svc-panel", jn), t("svc-item-value", Yn), t("svc-image-item-value", al), t("svc-dropdown-question", Ml), t("svc-dropdown-question-adorner", Nl), t("svc-widget-question", Fl), t("svc-question-banner", Ol);
}
ve(
  (u, t) => re.Instance.registerComponent(u, t)
);
const Zl = {
  install(u) {
    u.component("SurveyCreatorComponent", je), ve((t, e) => {
      u.component(t, e), re.Instance.registerComponent(t, t);
    });
  }
};
export {
  je as SurveyCreatorComponent,
  Zl as surveyCreatorPlugin
};
